export default {
    "accountValidateMsg" : "L\'account deve contenere da 6 a 30 caratteri, inclusi lettere, cifre e simboli (\".\", \"_\", \"@\"). Il primo carattere deve essere una cifra o una lettera.",
    "storeSuccess" : "Ricarica Riuscita",
    "editAccountTips" : "Per favore inserisci un nome account valido",
    "editPwdTips" : "Per favore inserisci una password valida",
    "editRepeatPwdTips" : "Inserisci nuovamente la tua password",
    "pwdRepeatTips" : "Le password non combaciano",
    "changePwdSucc" : "La tua password è stata cambiata",
    "bindEmail" : "Associa E-Mail",
    "errorVrifyCodeTips" : "Errore codice di verifica",
    "slectQuessionTips" : "Potresti scegliere una domanda di sicurezza per favore?",
    "answerTips" : "Per favore inserisci la risposta",
    "twoAnswerTips" : "Seleziona le domande di sicurezza create e inserisci le risposte corrette",
    "realNameValidateTips" : "Nome reale (4 a 60 caratteri)",
    "phoneValidateTips" : "Numero di telefono (6 a 18 digiti)",
    "areaSelectTips" : "Seleziona una regione",
    "iDCardValidataTips" : "Numero ID (1 a 60 digiti)",
    "changeProfileSucc" : "Info aggiornata salvata",
    "editVrfCodeTips" : "Per favore inserisci il codice di verifica",
    "securityQuestionTips" : "Crea domande di sicurezza per migliorare la sicurezza del tuo account. Quando si dimentica la password, è possibile rispondere alle domande per reimpostare la password.",
    "validateQuessionTips" : "Seleziona due domande diverse e verifica. È possibile ricreare le domande dopo la verifica.",
    "originPwd" : "Password originale",
    "newPwd" : "Nuova password",
    "changePwdSuccess" : "Password cambiata. Ti consigliamo di accedere di nuovo in questo momento per salvare i tuoi progressi.",
    "accountName" : "Nome account",
    "password" : "Inserisci la tua password",
    "repeatPassword" : "Per favore ripeti la tua password",
    "findPwdTips" : "Inserisci l\'account da cui desideri recuperare la password",
    "submit" : "invia",
    "send" : "Invia",
    "modify" : "modifica",
    "haveAgree" : "Accetta",
    "and" : "e",
    "privacyPolicy" : "Politica sulla Riservatezza",
    "completeness" : "Completamento",
    "gender" : "Sesso",
    "male" : "Maschio",
    "female" : "Femmina",
    "birthday" : "Compleanno:",
    "phone" : "Telefono",
    "region" : "Regione",
    "ID" : "ID",
    "accountSetting" : "Impostazione Account",
    "upgrade" : "Aggiorna",
    "profile" : "Profilo",
    "changePassword" : "Cambia Password",
    "securityQuestion" : "Domande di Sicurezza",
    "creatework_headerTitle" : "Crea Ticket",
    "mylist_headerTitle" : "Il Mio Ticket",
    "bindEmailTips" : "Verifica la tua e-mail per la sicurezza del tuo account. Se hai dimenticato la password, ti invieremo un\'email a questo indirizzo e-mail.",
    "enterEmailVrfcationTips" : "Inserisci qui il codice di verifica.",
    "cancel" : "ANNULLA",
    "bindTps" : "Associa il tuo account per poter giocare su multipli dispositivi!",
    "login" : "Accedi",
    "logout" : "Disconnetti",
    "bind" : "Associa Account",
    "feedback" : "Feedback",
    "terms" : "Accordi",
    "tips" : "Avviso",
    "debindTips" : "Dissociare potrebbe comportare  alla perdita di dati. Sei sicuro di voler dissociare?",
    "debindText" : "Dissocia",
    "guestSwitchTips" : "Account ospite rilevato. Dopo il login, i dati del tuo account ospite andranno persi. Continua?",
    "register" : "iscriviti",
    "realName" : "realName",
    "enterEmailTips" : "Inserisci il tuo E-Mail",
    "emailVAlidateMsg" : "e-mail invalido",
    "editEmaileTips" : "Inserisci il tuo E-Mail",
    "checkServiceTips" : "Leggere prima le Condizioni d\'uso e l\'Informativa sulla privacy.",
    "brithdayValidateTips" : "Inserisci la tua data di nascita",
    "facebookValidateTips" : "Account Facebook (1 a 60 caratteri)",
    "eritOriginPwdTips" : "Password originale",
    "submitSuccess" : "Inviato",
    "rebindEmail" : "Cambia E-Mail associato",
    "bindEmailSuccess" : "Email associato: \$email</br>Usa un’e-mail associato per verificare. Potrai resettare la tua e-mail dopo la verifica.",
    "reSetSecurityQuessoon" : "Hai creato le domande di sicurezza con successo </br></br>Seleziona varie domande e verifica. Puoi ricreare le domande dopo la verifica.",
    "canotModifyTips" : "Le modifiche NON sono consentite al momento dell\'invio, invio sicuro?",
    "rebindEmailTips" : "La tua e-mail è :\$email,tocca qui per ottenere il codice di verifica",
    "reGetVrfCode" : "Ottieni Codice",
    "findPwdWayTips" : "Seleziona uno dei seguenti metodi",
    "emailWay" : "Recupera attraverso email di sicurezza",
    "emailWayTips" : "Riceverai una e-mail di conferma e poi potrai resettare la password",
    "quessionWay" : "Recupera attraverso domande di sicurezza",
    "quessionWayTips" : "Rispondi alle domande di sicurezza create e resetta la password",
    "resetPwdBtn" : "Resetta la password",
    "lastStep" : "Precedente",
    "sendEmailTips" : "Ti abbiamo inviato una e-mail a\$email.<br>Inserisci il codice di verifica che hai ricevuto qui.",
    "setNewPwdTips" : "Complimenti!<br>Identità dell\'utente verificata. Ora puoi reimpostare la tua password.",
    "termsOfUse" : "Condizioni d’uso",
    "copy_success" : "Copiato",
    "creatework_create" : "Ticket",
    "creatework_createHolder" : "Seleziona Tipo",
    "creatework_title" : "Soggetto",
    "creatework_titleHolder" : "Inserisci un soggetto",
    "creatework_detail" : "dettagli",
    "creatework_detailHolder" : "La descrizione non deve contenere più di 200 caratteri",
    "creatework_uploadTips" : "Carica solo file jpg/png. Il file caricato deve essere inferiore a 5 MB.",
    "creatework_selectBox_selectTile" : "Tipo",
    "creatework_goGame" : "Ritorna",
    "creatework_history" : "Storia",
    "mylist_noYet" : "Nessun record",
    "mywork_solved" : "Problema risolto?",
    "mywork_service" : "Valutaci",
    "mywork_messageHolder" : "Nuovo messaggio",
    "mywork_score" : "Punteggio",
    "mywork_confirm" : "CONFERMA",
    "creatework_selectBox_selectList3" : "Altro",
    "creatework_selectBox_selectList2" : "Account",
    "close" : "Chiudi",
    "creatework_gameHolder" : "Seleziona un gioco",
    "creatework_serverHolder" : "Seleziona server",
    "contactService" : "Contatta CS",
    "FAQ" : "FAQ",
    "creatework_game" : "Gioco:",
    "creatework_server" : "Server:",
    "creatework_role" : "Personaggio:",
    "selectRoleName" : "Seleziona un personaggio",
    "creatework_noRole" : "Nessun personaggio",
    "creatework_noGame" : "Lista giochi vuota",
    "creatework_noServer" : "Lista server vuota",
    "termText" : "Accetto {mainHost}",
    "backLogin" : "RIFIUTA",
    "creatework_roleHolder" : "Accedi dopo aver scelto il tuo personaggio",
    "findPwdFailTips" : "Non hai impostato domande di sicurezza. Si prega di contattare il servizio clienti.",
    "payMall" : "Centro Commerciale",
    "selectPayment" : "quantità",
    "plzSelectPayWay" : "seleziona canale",
    "gainPlus" : "Aggiungi",
    "gainMorePlus" : "Aggiungi Più",
    "gainMostPlus" : "Massimo",
    "plzSelectPayType" : "Seleziona Metodo di Pagamento",
    "roleName" : "Personaggio",
    "payWay" : "Canale Pagamento",
    "plzSelectOtherWay" : "Canale Pagamento Alternativo",
    "payment" : "Quantità",
    "compensateTips" : "Il surplus ti verrà restituito in \$gameCode",
    "extaGain" : "Bonus",
    "gameGold" : "Valuta del Gioco",
    "compensate" : "Compensazione",
    "payWayPlus" : "Bonus Canale",
    "neddPay" : "Pagamento",
    "submitOrder" : "Invia",
    "screenshotTips" : "Avviso: fai uno screenshot del tuo ordine in caso di errore di transazione.",
    "storeFail" : "Impossibile ricaricare",
    "storeFailTips" : "Transazione fallita. Invia di nuovo l\'ordine o contatta il nostro servizio clienti.",
    "storeAcceptance" : "Processando",
    "storeSuccessTips" : "La transazione deve essere eseguita in 15 minuti.",
    "orderNumber" : "N. Ordine",
    "buyProduct" : "Ricarica Oggetto",
    "transactionAmount" : "Quantità",
    "failReason" : "Ragione",
    "payOntherORder" : "Nuovo ordine",
    "reStore" : "Ricarica di Nuov",
    "confirm" : "Conferma",
    "switch" : "Cambia Account",
    "completeTips" : "Ti preghiamo di inserire le tue informazioni personali.<mark class=\"yellowMarkColor\">Le informazioni non saranno più modificabili</mark>. Quando si tenta di recuperare un account smarrito, verrà richiesto di fornire informazioni personali corrette.",
    "creatework_selectBox_selectList0" : "Errore Gioco",
    "creatework_selectBox_selectList1" : "Errore Pagamento",
    "creatework_selectBox_selectList4" : "Errore Traduzione",
    "mywork_solvedText" : "Problema risolto",
    "browserPayErrBtnText" : "Errore Pagamento",
    "browserPaySucBtnText" : "Pagamento completato",
    "browserPayingTips" : "Reindirizzamento a piattaforma di terze parti.<br/>Può chiudere questa pagina dopo il pagamento.",
    "price_list_empty" : "Nessuna somma applicabile",
    "pointCardTips" : "Nota: Questo oggetto supporta solamente \$paymentAmount carta",
    "forgetPwd" : "Dimenticato la password?",
    "payCenter" : "Centro Ricarica",
    "willGet" : "Otterrai",
    "goods" : "oggetto",
    "discount" : "Bonus",
    "payDiscount" : "Compensazione",
    "payDiscountTips" : "I punti extra verranno convertiti in diamanti",
    "hasQuestionPlease" : "Se hai qualche domanda, per favore",
    "pwdValidateMsg" : "La password deve contenere da 6 a 20 caratteri",
    "payWayPlusC" : "Bonus Canale",
    "fwtk" : "TERMINI DEL SERVIZIO",
    "yszc" : "POLITICA SULLA RISERVATEZZA",
    "exchange" : "Scambio codice regalo",
    "remember" : "Ricorda la mia scelta",
    "thirdInfo" : "Info Account",
    "thirdInfoContent" : "Associa il tuo account nel Centro utenti in-game. Successivamente, accedi al gioco usando l\'account associato.",
    "unLink" : "Questo metodo non è attualmente supportato",
    "favour" : "Segnalibro",
    "goStoreTip" : "Passa alla pagina di pagamento",
    "go" : "Vai",
    "otherLogin" : "Altri metodi di accesso",
    "qrCodeTip" : "Scansiona il codice QR per iniziare!",
    "favourTip" : "Aggiungi la pagina ai segnalibri per giocare di nuovo più tardi!",
    "share" : "Condividi",
    "landscapeTip" : "Procedere in modalità verticale",
    "leaveTip" : "Exit the game?",
    "selectRole" : "Scegli personaggio",
    "selectMoney" : "Scegli un oggetto",
    "seletGameInfoFirst" : "Scegli il gioco",
    "lowerIE" : "Versione IE troppo vecchia",
    "linkTermText" : "Ho accettato {mainHost} [Termini d\'uso] e [Informativa sulla privacy]",
    "download" : "Scarica",
    "favourAndDownloadTip" : "Aggiungi questa pagina ai browser o scaricala su PC",
    "payReward" : "Ricarica Ricompensa",
    "hasEqualReward" : "Doppio bonus per entrambi i metodi di pagamento",
    "payBtnText" : "Pagamento",
    "storeHoaveReward" : "Ricarica Bonus",
    "showMorePayWay" : "Più Metodi",
    "needPaymentCount" : "Quantità",
    "orderDetail" : "Dettagli",
    "selectPayWayPlz" : "Scegli pagamento",
    "countryCode" : "Codice Paese",
    "deleteaccount_title1" : "Cancella Account",
    "deleteaccount_title2" : "Richiedi cancellazione account",
    "deleteaccount_step1_1" : "Il tuo account verrà bloccato per 14 giorni dalla cancellazione dell\'account. Dopo 14 giorni, il tuo account verrà eliminato definitivamente. Non sarai in grado di accedere con altri account social.",
    "deleteaccount_step1_2" : "È possibile revocare la cancellazione entro 14 giorni tramite il link seguente:",
    "deleteaccount_step1_3" : "Una volta eliminato, non sarai in grado di ripristinare le informazioni del tuo account. Non sarai rimborsato per eventuali perdite causate dalla cancellazione dell\'account.",
    "deleteaccount_step1_4" : "Sei sicuro di voler cancellare il tuo account?",
    "deleteaccount_step2_1" : "Conferma di voler eliminare il tuo account e personaggio.",
    "deleteaccount_step2_2" : "Scrivi \&quot;Cancella\&quot; per completare la cancellazione.",
    "deleteaccount_step3" : "Il tuo account verrà eliminato tra 14 giorni.",
    "accountrecovery_note" : "Nota:",
    "accountrecovery_tips" : "È possibile revocare la cancellazione dell\'account solo durante il periodo di congelamento di 14 giorni.",
    "accountrecovery_Submitted2" : "Revoca inviata. Il tuo account verrà ripristinato in seguito.",
    "accountrecovery_Failed" : "Fallita",
    "accountrecovery_Failed_1" : "Lo stato dell\'account è normale. Puoi accedere.",
    "accountrecovery_Failed_2" : "Informazioni sul personaggio non trovate.",
    "accountrecovery_success" : "Account ripristinato",
    "account_normal" : "Lo stato dell\'account è normale. Non è necessario ripristinare.",
    "account_unablerestore" : "L\'account è stato cancellato. Impossibile ripristinare.",
    "accountrecovery_roleHolder" : "Inserisci il nome del tuo personaggio",
    "accountrecovery_headerTitle" : "Revoca la cancellazione dell\'account",
    "guideTitle" : "Il tuo acquisto non è andato a buon fine. Si prega di contattare il nostro servizio clienti.",
    "accountFix" : "Recupero dell\'account",
    "inputAccount" : "Inserisci il nome dell\'account che desideri recuperare",
    "applyForAccountFix" : "Recupero dell\'account",
    "nonEnterItem" : "Informazioni da aggiungere: Data di registrazione; Numero di modello; Nome del dispositivo; Passaporto o numero ID, e-mail di contatto; Si prega di compilare gli spazi vuoti",
    "resetOT" : "Timeout, invia nuovamente la recensione",
    "addOT" : "Timeout, inviare nuovamente le informazioni aggiuntive",
    "errorPwd" : "La password deve contenere 6-20 caratteri, inclusi lettere, numeri, \ \". \", \ \"_ \", \ \"@ \"",
    "verifyAccount" : "Informazioni sull\'account mancanti, si prega di controllare di nuovo.",
    "selectRegisterTime" : "Scegli l\'orario di registrazione.",
    "enterBindEmail" : "Inserisci la tua email verificata.",
    "enterUsedPhoneType" : "Inserisci il modello del tuo telefono cellulare.",
    "enterIdfaGpid" : "Inserisci l\'UDID del tuo dispositivo.",
    "enterContactEmail" : "Formato errato dell\'indirizzo e-mail di contatto; Si prega di inserire nuovamente",
    "confirmTermsPrivacy" : "Si prega di leggere e accettare i termini del servizio e l\'informativa sulla privacy.",
    "enterRechargeRemark" : "Inserisci il tuo record di ricarica.",
    "uploadImg" : "Carica una scansione dell\'immagine del tuo ID, la dimensione massima è di 2 MB",
    "selectIDType" : "Seleziona il tipo di documento di identificazione.",
    "enterIDNum" : "Inserisci il numero del passaporto o il numero ID.",
    "enterIP" : "Inserire l\'indirizzo IP utilizzato per la registrazione.",
    "enterQueryNum" : "Inserisci l\'ID recensione",
    "enterQueryPwd" : "Inserisci la password di revisione",
    "errorQueryItem" : "ID recensione o password errati, riprovare",
    "enterPassword" : "Si prega di inserire una nuova password.",
    "enterPasswordAgain" : "Conferma la tua nuova password.",
    "enterPasswordNonSame" : "Password Inconsistente",
    "enterEmail" : "Inserisci il tuo E-Mail",
    "sendSuccess" : "Un e-mail è stato inviato",
    "enterCode" : "Inserisci il codice di verifica",
    "errorCode" : "Codice di verifica sbagliato",
    "selectQuest" : "Seleziona una domanda di sicurezza",
    "enterAnswer" : "Per favore inserisci la risposta",
    "selectDifferQuest" : "Seleziona 3 domande di sicurezza e rispondi.",
    "addSuccess" : "La tua informazione è stata inviata.",
    "picFormt" : "Il formato dell’immagine deve essere jpg, png o gif",
    "countdownBefore" : "Resetta conto alla rovescia",
    "countdownAfter" : "(Il link scadrà alle 00:00:00, si prega di inviare nuovamente la domanda)",
    "uploadDone" : "Caricamento completato",
    "uploadFail" : "Caricamento fallito",
    "applySuccess" : "Applicazione Approvata",
    "applyFailed" : "Applicazione Revocata",
    "resetQuestAlterFailed" : "Cambio domanda di sicurezza fallito.",
    "resetQuestError" : "Errore di input dati.",
    "resetQuestNone" : "Ordine di richiesta non trovato.",
    "resetQuestAltered" : "Le domande di sicurezza sono state modificate.",
    "illegalOperation" : "Operazione illegale",
    "queryNotExist" : "Il numero di richiesta non esiste.",
    "queryPasswordError" : "Errore Trova Password",
    "auditing" : "Approvazione In Attesa",
    "notPass" : "Negato",
    "suppleInformation" : "Invia informazioni supplementari",
    "suppleInformationUnHandle" : "Informazioni supplementari presentate, in corso di elaborazione.",
    "suppleInformationTimeout" : "Timeout invio di informazioni supplementari.",
    "repairedAccountSuccess" : "Riparazione account completata.",
    "repairedAccountLost" : "Operazione riparazione account fallita.",
    "loginStateNone" : "Non connesso o sessione scaduta.",
    "repairedAccountTimeout" : "La durata della riparazione dell\'account è scaduta.",
    "changePasswordSucc" : "Password cambiata.",
    "emailSendFailed" : "Invio Mail Fallito.",
    "emailSendLimit" : "La cassetta postale potrebbe non ricevere più codici di verifica oggi.",
    "repairedAccountTimeout2" : "Illegal operation account repair duration has expired.",
    "emailCodeSended" : "Codice di verifica e-mail è stato inviato.",
    "alterSuccess" : "Cambio salvato",
    "questionAlterSuccess" : "La domanda di sicurezza è stata modificata.",
    "username" : "Nome account",
    "code" : "Inserisci qui il codice di verifica.",
    "selectServiceType" : "Seleziona un tipo di servizio",
    "submitForm" : "Invia il formulario",
    "apply" : "Applica",
    "reviewApplicationStatus" : "Revisione Stato dell\'applicazione",
    "instantReviewOfTheStatus" : "Revisione Istantanea dello stato",
    "reviewStatus" : "Stato Revisione",
    "backToLogin" : "Torna all’accesso",
    "previous" : "Precedente",
    "applyDesc" : "Inserisci le informazioni in modo che possiamo aiutarti. È necessario riempire gli spazi vuoti con un *. Se nel tuo account mancavano tali informazioni, inserisci \"Nessuno\".",
    "additionalServices" : "Servizi addizionali",
    "resetSecurityEmail" : "Resetta e-mail di sicurezza",
    "resetSecurityQuest" : "Resetta Domande di Sicurezza",
    "registrationDate" : "Data Registrazione",
    "month" : "Mese",
    "year" : "Anno",
    "emailBound" : "E-mail associato",
    "modelNumber" : "Tipo modello cellulare;",
    "deviceName" : "Nome Dispositivo",
    "provideRecharge" : "Forniscici un registro di ricarica dettagliato e completo, inclusi Tempo, Metodo, Importo, Numero ordine e ID transazione per consentirci di confermare.",
    "selectCountry" : "Regione",
    "passportID" : "Passaporto/ ID",
    "upload" : "Carica",
    "del" : "Cancella",
    "pleaseUpload" : "Carica una scansione dell\'immagine del tuo ID, la dimensione massima è di 2 MB",
    "uploadAgain" : "Carica di nuovo",
    "enterDesc" : "Inserisci qualsiasi informazione che dimostri la proprietà dell\'account",
    "contactEmail" : "E-Mail di Contatto",
    "applyNoteAttr" : "Nota",
    "applyNoteDate" : "si prega di fornire il proprio indirizzo e-mail in modo da poter ricevere i risultati della propria candidatura",
    "agree" : "Ho accettato",
    "UJOYTerms" : "Condizioni d’uso",
    "privacy" : "Politica sulla Riservatezza",
    "reviewStatusOfAccountFix" : "Verifica lo stato della riparazione dell\'account",
    "enterReviewID" : "Inserisci l\'ID recensione",
    "enterReviewPwd" : "Inserisci la password di revisione",
    "review" : "Revisione",
    "reviewNoteAttr" : "Nota",
    "reviewNoteData" : "Controlla la tua e-mail di contatto nel caso in cui hai dimenticato l\'ID recensione e la password di revisione",
    "haveResetInfo" : "Hai\ resettato la tua info",
    "resetProfile" : "Resetta il tuo profilo",
    "desc" : "Congratulazioni! Domanda approvata! Si prega di ripristinare il profilo.",
    "changePwd" : "Cambia Password",
    "resetPwd" : "Resetta Password",
    "reset" : "Resetta",
    "enterNewPwd" : "Inserisci la nuova password",
    "confirmNewPwd" : "Conferma la tua nuova password.",
    "successResetPwd" : "Password resettata con successo",
    "bindSecurityEmail" : "Associa e-mail di sicurezza",
    "resetPwdDesc" : "Reimposta password quando hai dimenticato la password o l\'account è stato rubato",
    "bindCommon" : "Associa",
    "sendCommon" : "Invia",
    "enterVcode" : "Inserisci il codice di verifica",
    "successResetEmail" : "Reset e-mail di sicurezza riuscito",
    "resetQuest" : "Resetta Domande di Sicurezza",
    "resetQuestDesc" : "Reimposta password quando dimentichi la password o ritieni che le informazioni del tuo account siano state rubate",
    "successResetQuest" : "Reset Domande di Sicurezza riuscito",
    "hide" : "Nascondi",
    "addRegisterTime" : "Tempo registrazione;",
    "modelNum" : "Numero Modello: IDFA/GPID",
    "registrationIP" : "Registrazione IP;",
    "addRechargeRecord" : "Record ricarica;",
    "serviceReply" : "Risposta dal Servizio Clienti:",
    "addDataLimitTime" : "Data per Aggiungere Informazione Aggiuntiva:",
    "addMoreInfo" : "Aggiungi Più Informazione",
    "applicationSubmit" : "Applicazione inviata",
    "underReviewStatus" : "Il tuo profilo è in fase di revisione, riceverai risposta il giorno lavorativo successivo. Stato della revisione:",
    "reviewID" : "ID Revisione",
    "reviePwd" : "Password Revisione",
    "enterReviewIDNPwd" : "Immettere l\'ID revisione e la Password revisione per controllare lo stato",
    "homepage" : "Homepage",
    "checkEmailAttr" : "Nota",
    "checkEmailData" : "Controlla la tua e-mail di contatto nel caso in cui hai dimenticato l\'ID recensione e la password di revisione",
    "underReview" : "Sotto Revisione",
    "underReviewReply" : "Il tuo profilo è in fase di revisione. Ti risponderemo al più presto. Grazie per la vostra pazienza!",
    "failed" : "Applicazione Fallita",
    "reason" : "Motivo: ### Pertanto, l\'applicazione non è riuscita, si prega di fornire informazioni corrette, il nostro staff sarà di aiuto. Grazie per la collaborazione!",
    "underReviewAdd" : "Il tuo profilo è in fase di revisione. Parte delle informazioni è mancante o incoerente, si prega di aggiungere ulteriori informazioni per confermare!",
    "addInfoRequired" : "Informazione Aggiuntiva richiesta",
    "dateForAddInfo" : "Data per Aggiungere Informazione Aggiuntiva:",
    "addInfo" : "Informazione Aggiuntiva",
    "addInfoSubmit" : "Ulteriori informazioni sono state inviate! Grazie per la vostra pazienza!",
    "hasBeenRepaired" : "L’account è stato riparato",
    "opExpired" : "Operazione riparazione account scaduta.",
    "approved" : "Approvato",
    "haveSubmitted" : "Hai\ inviato",
    "sessionExpired" : "Non hai ancora eseguito l’accesso o la sessione è scaduta",
    "submitted" : "Inviato",
    "addItemRegisterDate" : "E-mail;",
    "addItemDeviceNumber" : "UDID;",
    "reasonItemPwd" : "Numero ID Inconsistente;",
    "addItemIDPhoto" : "Foto ID;",
    "idfaTitle" : "Come trovare il dispositivo IDFA o GPID?",
    "idfaSubTitle1" : "Per l\'utente iOS: come trovare il tuo IDFA",
    "idfaSubTitle1Desc1" : "1.Scarica questa app 【<em>MyIDFA</em>】dall’App Store",
    "idfaSubTitle1Desc2" : "2.Apri questo <em>app</em> e troverai il tuo dispositivo <em>IDFA</em>.",
    "idfaSubTitle2" : "Per utenti Android: come trovare il tuo GPID",
    "idfaSubTitle2Desc1" : "1.tocca il bottone <em>“settings”</em>",
    "idfaSubTitle2Desc2" : "2.tocca l’icona <em>“Google”</em> sotto la pagina <em>ACCOUNTS</em>",
    "idfaSubTitle2Desc3" : "3.poi tocca l’icona <em>“Ads”</em> , e troverai il tuo <em>GPID</em>",
    "uploadIDCard" : "Carica una scansione dell\'immagine del tuo ID, la dimensione massima è di 2 MB",
    "uploadTipsBefore" : "La dimensione del file non può superare",
    "uploadTipsAfter" : "M",
    "submitError" : "Errore causato dalla mancanza del numero ID o delle informazioni errate sull\'account.",
    "applyLimitError" : "Limite di applicazione giornaliero superato. (3 volte al giorno)",
    "applyDisabled" : "Puoi inviare solo una volta ogni 10 minuti.",
    "inputDataError" : "I dati non sono completati.",
    "dataException" : "Eccezione dati",
    "picSizeLimit" : "La dimensione della foto non deve superare i 5MB",
    "picTypeLimit" : "Carica solamente file JPG, PNG, GIF",
    "picNull" : "L’immagine è vuota",
    "alteredPassword" : "Password è stata cambiata",
    "inputError" : "Errore di input.",
    "pwdChangefailed" : "Cambio password fallito.",
    "sendEmailCodeDisabled" : "Il codice di verifica può essere inviato di nuovo solo dopo un periodo di tempo.",
    "alteredEmail" : "L’e-mail è stato cambiato.",
    "inputEmailError" : "Errore input e-mail",
    "operationFailed" : "Operazione fallita",
    "codeNull" : "Non hai ancora inserito un codice di verifica.",
    "findPwd" : "Password dimenticata",
    "findAccountAndPwd" : "Dimenticato account/password",
    "usualDeviceNum" : "Numero Modello: IDFA/GPID",
    "usualPhoneNum" : "Nome Dispositivo",
    "registerTimeError" : "Data Registrazione inconsistente;",
    "bindEMailError" : "E-Mail Associato Inconsistente;",
    "rechargeRecordError" : "Record Ricarica Inconsistente;",
    "registerIPError" : "Indirizzo IP di Registrazione Inconsistente;",
    "deviceNumError" : "IDFA/GPID Inconsistente;",
    "deviceModelError" : "Modello Dispositivo Inconsistente;",
    "confirmTerms" : "Accetta i Termini di Servizio",
    "applyFixAccount" : "Se gli approcci di sopra non funzionano, è possibile richiedere il <span>recupero dell\'account</span>.",
    "findPwdByFixAccount" : "Si consiglia di impostare un\'e-mail di sicurezza per il recupero dell\'account.",
    "connectFail" : "Disconnesso dai servizi Google, riprova",
    "h5_favour_has_gift" : "Aggiungi al browser! (Questo account ha già reclamato il premio)",
    "h5_favour_get_gift" : "Congratulazioni! Hai ottenuto la ricompensa. Si prega di controllare nel gioco.",
    "h5_get_gift_fault" : "Impossibile reclamare. Riprova più tardi e contatta il nostro CS se il problema persiste.",
    "h5_favour_please_select" : "Per favore, scegli il personaggio",
    "h5_favour_login_get" : "Accedi e aggiungi ai segnalibri il browser per richiedere un premio!",
    "h5_favour_tip" : "Aggiungi un segnalibro al browser per richiedere un premio!",
    "h5_favour_select_serve" : "Scegli un server",
    "h5_favour_select_role" : "Per favore, scegli il personaggio",
    "store_product_paytype_error" : "Non è possibile acquistare l\'oggetto selezionato tramite questo metodo di pagamento.",
    "SwitchWithThirdWay" : "Cambia a \${type}",
    "moreGame" : "più giochi",
    "serviceTitle" : "Servizio",
    "h5_download_login" : "Per favore accedi prima.",
    "h5_download_tips" : "Avvia il gioco dal cliente.",
    "h5_download_repeat_get" : "Hai reclamato questo pacco regali.",
    "h5_download_succ" : "Scarica prima il cliente.",
    "h5_download_repeat_role" : "Personaggio associato",
    "currentLoginAccount" : "Account attuale:",
    "fb_canvas_fullscreen" : "Espandi",
    "fb_canvas_website" : "Homepage",
    "fb_canvas_like_share" : "Condividi",
    "fb_canvas_service" : "Supporto",
    "fb_canvas_login_fail" : "Accesso fallito",
    "fb_canvas_pay_return" : "Hai annullato la transazione",
    "fb_canvas_root_tip" : "Accedi a Facebook per autorizzare prima",
    "h5_popup_title" : "Payment way",
    "h5_popup_submit" : "Pay",
    "h5_popup_last_used" : "Last used",
    "h5_popup_quit_tips" : "Are you sure to cancel payment",
    "h5_popup_quit_check" : "YES",
    "h5_popup_quit_cancel" : "NO",
    "h5_popup_currency_sign" : "\$",
    "h5_popup_product_empty" : "Product information has not been obtained yet. Please refresh page",
    "h5_popup_server_empty" : "There is no server list yet. Please refresh page",
    "aboutRelevanceAccount" : "Already have an account?",
    "selectLoginType" : "Select a login method",
    "touristDescription" : "If you already have an account, you can log in as a guest and then use the OTP (One-Time Password) feature in the user center to switch accounts. This feature requires the OTP functionality to be set up on your mobile device in the user center.",
    "touristSuggest" : "If you already have an account, you can log in as a guest and then tap the \"Switch Account\" option in the user center. From there, you can log in using a previously bound social media account.",
    "h5_tourist_remenber" : "Remember me for 14 days",
    "account_czsm1" : "1、全てのゲームデータが新しい端末に引き継がれます。OSの異なる端末で引き継ぐことも可能です；",
    "account_czsm2" : "2、引き継ぐ時のパスワードを登録してください。",
    "account_czsm3" : "3、セキュリティ保護のため、",
    "account_wzfdmm" : "大文字と小文字を区別して、6-16文字のパスワードをご入力",
    "account_qzcsrmm" : "再度パスワードをご入力",
    "account_fxyjm" : "引き継ぎコード発行",
    "account_yjmsm1" : "1、タイトル画面にある「ユーザーセンター」をタップ、「切り替え」のページで引き継ぎを行ってください。",
    "account_yjmsm2" : "2、引き継ぎナンバーに使用期限はございません。",
    "account_yjmsm3" : "3、引き継ぎコードは一度しか使えません。再度引き継ぐことができます。",
    "account_yjmsm4" : "4、アカウントを保護するため、引き継ぎコードを他人に教えないようにしてください。",
    "account_fz" : "コピー",
    "account_cxfx" : "新規で発行する",
    "account_czsm4" : "アカウントを連携",
    "account_czsm5" : "してください。",
    "account_yjm" : "引き継ぎコード",
    "account_16wzzj" : "パスワードの長さは6～16文字にする",
    "account_qsrzqdyjmhmm" : "正しい引き継ぎコードとパスワードを入力してください。",
    "account_yj" : "引き継ぎ",
    "accoun_lcsrdmmbyz" : "パスワードの両回の入力は一致しない",
    "deleteaccount_step3_1" : "entro 14 giorni. Revoca ora?",
    "account_syyjm" : "1. 引き継ぎコードを使ってゲームデータがこの端末に引き継がれます。",
    "account_yjmznsyyc" : "2. 引き継ぎコードは一度しか使えず、再発行することができます。",
    "account_sryjm" : "引き継ぎコードを入力",
    "account_srmm" : "パスワードを入力",
    "h5_header_gift" : "",
    "h5_award_popup_type" : "",
    "h5_award_popup_content" : "",
    "h5_award_popup_code" : "",
    "h5_favour_gift_name" : "",
    "h5_download_gift_name" : "",
    "h5_award_popup_exchange_way" : "",
    "h5_succ_get_gift" : "",
    "h5_exchange_info_title" : "",
    "h5_exchange_info_1" : "",
    "h5_exchange_info_2" : "",
    "h5_check_gift" : "",
    "account_delete_scdqzh" : "Are you sure you want to delete the account along with its data?",
    "account_delete_fwq" : "Server",
    "account_delete_zhm" : "Character",
    "account_delete_jshflj" : "Character retrieval link",
    "account_delete_qzyzmdxx" : "(Case sensitive)",
    "account_delete_jtbcysxx" : "You are advised to take a screenshot of the above information for account retrieval.",
    "deleteaccount_step3_2" : "Dopo 14 giorni, il tuo account verrà eliminato. Non sarai in grado di ripristinare il tuo account. Perderai tutte le informazioni del tuo account.\n\nÈ possibile revocare la cancellazione dell account tramite",
    "h5_guest_login" : "Guest",
    "h5_click_copy" : "",
    "questionnaire_btn" : "questionnaire investigation",
    "h5_header_store_text" : "Recharge",
    "h5_header_home_text" : "Homepage",
    "h5_check_gift_list_text" : "Info ricompensa",
    "yourServer" : "Il tuo Server",
    "allServer" : "Tutti i Server",
    "h5_header_screen" : "Schermo intero",
    "h5_verticalTip" : "Modalità orizzontale consigliata.",
    "h5_third_party_login_tips" : "If you want to log in using a social media account (such as Facebook, Google, Twitter, etc.), you can first log in as a guest and then bind your social media account in the user center.",
    "webStoreUidTitle" : "",
    "webStoreUidTips" : "",
    "webStoreUidGuide" : "",
    "webStoreUidInputt" : "",
    "feedbackTips" : "",
    "recentPlay" : "Recente",
    "moreGames" : "Più",
    "previousSelect" : "Previous",
    "payAgainBtn" : "Top-up again",
    "packageTypeName" : "Pack",
    "coinTypeName" : "Top-up",
    "cardTypeName" : "Monthly Card",
    "orderNormal" : "default",
    "orderPriceUp" : "Price↑",
    "orderPriceDown" : "Price↓",
    "returnSelectRole" : "Return",
    "jiamaInfo" : "Bonus Metodo di Pagamento\nValuta del bonus = Importo pagato*tasso di cambio * tasso del bonus x Bonus metodo di pagamento\nValuta del bonus = Importo pagato*tasso di cambio*tasso del bonus\n*Nota: la valuta del bonus non verrà conteggiata per eventi di ricarica o ESP VIP.*Per i giochi lanciati a livello globale, l\'importo del pagamento viene calcolato in dollari statunitensi. Per qualsiasi domanda, contatta il servizio clienti.",
    "lastSelectTag" : "Used previously",
    "onestore_subscribe_manage" : "Manage",
    "onestore_subscribe_entrance" : "OneStore Subscription",
    "onestore_subscribe_has_expire" : "Expired",
    "onestore_subscribe_expire_time" : "Expire on \${month}/\${day}/\${year}",
    "onestore_subscribe_privacy" : "About Subscription and Privacy",
    "onestore_subscribe_cancel_subscribe" : "Cancel Subscription",
    "onestore_subscribe_info_title" : "Subscription Info",
    "onestore_subscribe_option_title" : "Options",
    "onestore_subscribe_do_not_subscribe" : "No subscribed items.",
    "onestore_subscribe_get_role_fail" : "Failed to subscribe. Please open this page again in the game.",
    "onestore_subscribe_later" : "Later",
    "onestore_subscribe_confirm" : "Confirm",
    "onestore_subscribe_confirm_cancel" : "Confirm Cancellation",
    "onestore_subscribe_popup_tip" : "If you cancel now, you can still access your subscription until \${month}/\${day}/\${year}.",
    "onestore_subscribe_detail_tip" : "Subscribed item will be renewed on \${month}/\${day}/\${year} (Price: \${prices}/month). Subscription can be canceled 1 day before it expires.",
    "onestore_subscribe_expired_tip" : "Please subscribe the expired item from the in-game Mall/Shop",
    "onestore_subscribe_goon_sub" : "Renew on \${month}/\${day}/\${year}",
    "onestore_subscribe_has_cancel_tip1" : "Subscription canceled. You can still access your subscription until \${month}/\${day}/\${year}.",
    "onestore_subscribe_has_cancel_tip2" : "If you wish to subscribe again. Please do so in the in-game Mall/Shop.",
    "onestore_subscribe_cancel_fail" : "Failed to cancel subscription. Please try again later.",
    "onestore_subscribe_cancel_fail_title" : "Cancel Subscription",
    "apple_deleteaccount" : "Delete Account",
    "apple_deleteaccount_title" : "Request account deletion",
    "apple_deleteaccount_step1_1" : "Please read the following terms and conditions carefully:",
    "apple_deleteaccount_step1_2" : "Your account will be frozen for 14 days since the account deletion.",
    "apple_deleteaccount_step1_3" : "Your account will be <span class=\"highlight\">permanently deleted</span> if you do not revoke the deletion process in 14 days. Upon deletion of your account, you will not be able to use it to log into the game. All information on your account will be deleted.",
    "apple_deleteaccount_step1_4" : "If you wish to unlink social media account from the account, please contact the customer service team for unlinking operation before deleting your account. Otherwise, upon successful deletion of your account, you will not be able to use your linked social media account to log into the game.",
    "apple_deleteaccount_step1_5" : "Please make sure you have properly disposed your virtual assets in the game before applying for the deletion of your account.<span class=\"highlight\">If you wish to apply for refund, please also do it before deleting your account</span>.",
    "apple_deleteaccount_step1_6" : "You may revoke the deletion within the 14 days through the link below, please save the link in advance:",
    "apple_deleteaccount_step2_1" : "Have you properly disposed your virtual assets in the game? If you haven\'t, please contact the customer service team for the matter before submitting an account deletion request.",
    "apple_deleteaccount_step2_2" : "Please save your server and character information which will be required for restoring your account.",
    "apple_deleteaccount_step2_3" : "Please type \"Delete\" to complete the deletion",
    "apple_deleteaccount_step3_1" : "Your account deletion request has been submitted. The following account is now frozen:",
    "apple_deleteaccount_step3_2" : "We will permanently delete your account after 14 days if there is no further request for revoking the deletion from you.",
    "apple_deleteaccount_step3_3" : "You can visit the following link to revoke the deletion within the 14 days period",
    "apple_deleteaccount_step4_1" : "You have deleted your old account. Please log in with a new account next time.",
    "apple_deleteaccount_agree" : "I have read and agree to the terms and conditions above",
    "apple_deleteaccount_server" : "Server",
    "apple_deleteaccount_roleName" : "Character",
    "copyLink" : "Copy Link",
    "copyTextAndImg" : "please copy and save the link or take a screenshot",
    "copyLinkAndRoleInfo" : "Copy Link & Character",
    "hasCopy" : "Copied to clipboard",
    "quickcard_tips" : "The information of your credit card has been encrypted and secured by Worldpay. The displayed information is only to provide a better experience.",
    "quickcard_use_new_card" : "New credit card",
    "edit" : "Edit",
    "save" : "Save",
    "quickcard_confirm_delete" : "Delete?",
    "quickcard_popup_tip" : "If you want to use this card again after deleting it, please choose the \"New credit card\" option.",
    "quickcard_result_tip_one" : "se scegli di salvare il numero della tua carta nella pagina precedente, raccoglieremo i dati della tua carta (**** **** **** 1234) in versione crittografata.",
    "quickcard_result_tip_two" : "Memorizziamo i dettagli crittografati solo per tua comodità e non devi inserire i numeri di carta al tuo prossimo acquisto.",
    "quickcard_learn_more" : "Learn more 》",
    "quickcard_info_title" : "Dichiarazioni sulle Credenziali Archiviate",
    "quickcard_info_tip_one" : "Per proteggere meglio la sicurezza dei dati dei clienti. Visa e Mastercard stanno introducendo nuove definizioni per queste \"credenziali archiviate\" e nuove regole per le credenziali archiviate e le transazioni avviate dal commerciante.",
    "quickcard_info_tip_two" : "Quando effettui un acquisto sul nostro sito Web, raccogliamo i dati della tua carta (1234 **** **** 1234) in versione crittografata. Conserveremo i dettagli crittografati per 4 anni e aggiorneremo il contratto, l\'informativa sulla privacy su il nostro sito Web in caso di modifiche. Archiviamo i dettagli crittografati solo per tua comodità e non devi inserire i numeri della carta al tuo prossimo acquisto.",
    "search_product" : "trova oggetto",
    "search_price" : "trova prezzo",
    "price" : "prezzo",
    "product_no_found" : "No items are found",
    "price_no_found" : "No price are found",
    "search_no_found" : "No items/price are found",
    "product" : "item",
    "store_tag_hot" : "HOT",
    "store_tag_discount" : "Discount",
    "store_tag_double" : "Double",
    "store_tag_treble" : "Treble",
    "store_tag_sale" : "SALE",
    "store_tag_top_seller" : "TOP SELLER",
    "store_tag_off_10" : "10%OFF",
    "store_tag_off_20" : "20%OFF",
    "store_tag_off_30" : "30%OFF",
    "store_tag_off_40" : "40%OFF",
    "store_tag_off_50" : "50%OFF",
    "store_tag_off_60" : "60%OFF",
    "store_tag_off_70" : "70%OFF",
    "store_tag_off_80" : "80%OFF",
    "store_tag_off_90" : "90%OFF",
    "store_tag_event" : "Event",
    "store_tag_daily" : "Daily",
    "store_tag_weekly" : "Weekly",
    "store_tag_monthly" : "Monthly",
    "subscriptionTypeName" : "subscription",
    "useDoubleSend" : "Use Box Multiplier?",
    "doubleSendInfo" : "Since you used a Box Multiplier, some of the items you purchased were doubled (as shown at the bottom)!",
    "storeRoleTitle" : "Scegli Personaggio",
    "storeSocialLogin" : "Accedi con account SNS",
    "storeAccountIdLogin" : "Accedi con ID account",
    "storeInputId" : "Enter account ID",
    "storeSearch" : "Cerca",
    "storeSelectProductTitle" : "Scegli Oggetti",
    "storeInputNameSearch" : "Inserisci nome oggetto e cerca",
    "storeInputPriceSearch" : "Inserisci prezzo oggetto e cerca",
    "storeNoFindProduct" : "Oggetto non trovato. Riprova.",
    "storePriceUp" : "Prezzo↑",
    "storePriceDown" : "Prezzo↓",
    "storeLookDetail" : "Dettagli",
    "storeChangeProduct" : "Cambia Oggetto",
    "storeWelcome" : "Benvenuto",
    "storeLookMore" : "Più",
    "storeHasSelect" : "Oggetto Selezionato",
    "storeTotal" : "Totale",
    "storeExtra" : "Bonus",
    "storeProductDetail" : "Dettagli",
    "storeUidGuideStep1" : "Tocca Impostazioni > Più > Account",
    "storeUidGuideStep2" : "Inserisci l\'ID dell\'account durante la ricarica",
    "storeSelectAndLook" : "Seleziona prima il tuo personaggio",
    "storeSwitchWay" : "Cambia Metodo di Login",
    "type1" : "Vendita Giornaliera",
    "type2" : "Eroe",
    "type3" : "Equip. Battaglia",
    "type4" : "",
    "type5" : "Chip",
    "type6" : "Nova",
    "type7" : "Risorse",
    "type8" : "Velocizz. Costruzione",
    "type9" : "Oggetti Rari",
    "type10" : "Alleanza",
    "type11" : "Diamante",
    "type12" : "Modulo",
    "type13" : "Cubo",
    "type14" : "",
    "type15" : "Nanoarma",
    "type16" : "Premio Finale",
    "type17" : "",
    "type9999" : "Offerta Limitata",
    "type10000" : "Centro Regali",
    "type10001" : "Eventi Festività",
    "typeother" : "Altro",
    "switchChar" : "Cambia Personaggio",
    "howToFindUid" : "Come trovo l\'ID del mio account?",
    "choosePayWay" : "Scegli un Metodo di Pagamento",
    "new_apple_deleteaccount_stepsub_title" : "Annulla Auto-Rinnovo",
    "new_apple_deleteaccount_stepsub_1" : "Un abbonamento con rinnovo automatico si trova nel tuo account. Ti consigliamo di annullare il rinnovo automatico prima di eliminare il tuo account per evitare acquisti non intenzionali.",
    "new_apple_deleteaccount_stepsub_2" : "Annulla Auto-Rinnovo",
    "new_apple_deleteaccount_stepsub_later" : "Dopo",
    "new_apple_deleteaccount_stepsub_now" : "Ora",
    "new_apple_deleteaccount_title" : "Richiedi l\'eliminazione dell\'account",
    "new_apple_deleteaccount_step1_1" : "Per favore leggi attentamente i seguenti termini e condizioni:",
    "new_apple_deleteaccount_step1_2" : "Il tuo account sarà <span class=\"highlight\">eliminato definitivamente</span> al momento della cancellazione. NON potrai usarlo per accedere al gioco. Tutte le informazioni cancellate del tuo account NON saranno ripristinabili.",
    "new_apple_deleteaccount_step1_3" : "Se desideri scollegare l\'account di social media dall\'account del gioco, contatta il team del servizio clienti per l\'operazione di scollegamento prima di eliminare il tuo account. In caso contrario, dopo aver eliminato con successo il tuo account, non sarai in grado di utilizzare il tuo account di social media collegato per accedere al gioco. Assicurati di aver smaltito correttamente le tue risorse virtuali nel gioco prima di richiedere la cancellazione del tuo account.",
    "new_apple_deleteaccount_step1_4" : "<span class=\"highlight\">Se desideri richiedere il rimborso, fallo prima di eliminare il tuo account. </span>Assicurati di aver smaltito correttamente le tue risorse virtuali prima di eliminare il tuo account.",
    "new_apple_deleteaccount_step2_1" : "Hai smaltito correttamente le tue risorse virtuali nel gioco? In caso contrario, contatta il team del servizio clienti per la questione prima di inviare una richiesta di eliminazione dell\'account.",
    "new_apple_deleteaccount_step2_2" : "Si prega di digitare \"Delete\" per completare l\'eliminazione. La cancellazione dell\'account non può essere revocata una volta eseguita.",
    "new_apple_deleteaccount_step2_3" : "Si prega di digitare \"Delete\" per completare l\'eliminazione",
    "new_apple_deleteaccount_step3_1" : "La tua richiesta di eliminazione dell\'account è stata inviata. Da allora il seguente account è stato eliminato:",
    "new_apple_deleteaccount_step3_2" : "Crea un nuovo account se desideri accedere nuovamente al gioco.",
    "new_apple_deleteaccount_step4_1" : "Hai eliminato il tuo vecchio account. Accedi con un nuovo account la prossima volta.",
    "currencyTypeName" : "Valuta",
    "has_select_product" : "I Tuoi Oggetti:",
    "n_product" : "\${n}",
    "look_detail_product" : "Visualizza Tutto",
    "limit_buy_product" : "Limite di acquisto per questo oggetto: \${n}",
    "limit_order" : "Puoi acquistare solo un massimo di \${n}oggetti ogni volta.",
    "limit_order_remove_tip" : "Hai raggiunto il limite di acquisto per alcuni oggetti in questo carrello. Vuoi rimuoverli?",
    "paytype_limit" : "Questo metodo di pagamento non può essere utilizzato per acquistare alcuni dei tuoi oggetti. Scegli un metodo di pagamento diverso o prova ad acquistarli separatamente.",
    "check_remove_cart" : "Rimuovi dal carrello?",
    "remove_cart" : "Rimuovi",
    "confirm_product" : "Conferma",
    "select_paytype" : "Seleziona Metodo di Pagamento",
    "cart_is_empty_tip" : "Nessun oggetto trovato. Si prega di selezionare prima un oggetto.",
    "thirty_tip" : "Se gli oggetti che hai acquistato non arrivano entro 30 minuti, contatta il nostro servizio clienti.",
    "total_n_product" : "Oggetto x\${n}",
    "look_detail_of_cart" : "Visualizza Tutto",
    "order_detail" : "Lista Oggetti",
    "total_detail" : "Quantità:",
    "add_to_cart" : "Aggiungi al Carrello",
    "back_to_select" : "Indietro",
    "fail_and_later" : "Item info error. Please try again later.",
    "nextStep" : "Conferma",
    "pnsGameName" : "Puzzles & Survival",
    "enterOfficial" : "Visita \nSito web",
    "visitorLogin" : "Ospite",
    "tokenLogin" : "OTP",
    "fbLogin" : "accedi con Facebook",
    "googleLogin" : "Accedi con Google",
    "twitterLogin" : "Accedi Con Twitter",
    "vkLogin" : "Accedi con VK",
    "agreementTextStart" : "Accedendo al gioco, confermi di aver letto e accettato iTermini di Servizio el\'Informativa sulla Privacy.",
    "userCenter" : "Centro Utenti",
    "welcomeBack" : "Bentornato",
    "continueGame" : "INIZIA",
    "officialPay" : "Centro di Ricarica",
    "changeAccount" : "Cambia Account",
    "back" : "Indietro",
    "tokenKey" : "OTP",
    "inputUid" : "Inserisci il tuo UID",
    "inputToken" : "Inserisci la tua OTP",
    "inputCkCode" : "Digita il testo",
    "enterGame" : "INIZIA",
    "tokenTip" : "Proteggi il tuo account con la Verifica OTP",
    "howToGetToken" : "Come ottenere la mia password monouso (OTP)?",
    "getStep1" : "Passaggio 1: vai su Impostazioni > Account > Centro Utenti",
    "getStep2" : "Passaggio 2: Tocca OTP",
    "getStep3" : "Passaggio 3: copia e inserisci il tuo UID e la password monouso (OTP)",
    "copy" : "Copia",
    "lastRefresh" : "Si aggiorna tra:",
    "second" : "s",
    "immediatelyRefresh" : "Aggiorna Ora",
    "frequently" : "Operazione troppo frequente. Per favore riprova più tardi.",
    "loginFail" : "Accesso non riuscito. Password errata.",
    "tokenIntro" : "Informazioni su One-Time Password (OTP)",
    "tokenIntro1" : "1. Le password monouso scadono tra 120 secondi. Usale con saggezza per mantenere il tuo account sicuro e protetto.",
    "tokenIntro2" : "2. Lo staff di non ti chiederà la tua password monouso. Si prega di non condividere o fornire mai la password.",
    "nextStep1" : "Conferma",
    "couponCanUse" : "Utilizzabile",
    "couponCanNotUse" : "Non Utilizzabile",
    "couponHasNoCoupon" : "Nessun buono",
    "couponUseTip" : "Usa 1 buono per ogni ordine",
    "couponValidTime" : "Validità",
    "couponFuilCanUse" : "Utilizzabile per ordini oltre \${price} \${currency}",
    "couponNoLimit" : "Nessun limite",
    "couponAllProductCanUse" : "Tutti gli oggetti",
    "couponPartProductCanUse" : "Oggetti specifici",
    "couponPartPaytypeCanUse" : "Canali di pagamento specifici",
    "couponOnlyCoinCanUse" : "Solo per valuta di gioco",
    "couponOnlyDiamondCanUse" : "Solo per diamanti",
    "couponOnlyPackageCanUse" : "Solo per pacchetti",
    "couponOnlySubCanUse" : "Solo per iscrizioni",
    "couponOnlyDaibiCanUse" : "Solo per gettoni",
    "couponMaxDiscount" : "Sconto fino a \${price} \${currency}",
    "couponHasUsed" : "Usato",
    "couponReductionType" : "Deduzione",
    "couponDiscountType" : "Sconto",
    "couponUseNow" : "Usa",
    "couponHasNoSelect" : "Non utilizzando buono",
    "couponHasSelectQuan" : "Scontato:",
    "couponSubmitTip" : "Buoni verranno usati",
    "couponCanUseQuan" : "Buoni",
    "couponOrderTotal" : "Totale",
    "couponHasDiscount" : "Sconto",
    "couponPayTotal" : "Pagamento",
    "couponCancel" : "Annulla",
    "couponConfirm" : "Conferma",
    "uidLoginName" : "Accedi con OTP",
    "uidToken" : "OTP",
    "uidInputUid" : "Inserisci il tuo UID",
    "uidInputToken" : "Inserisci la tua OTP",
    "uidInputCode" : "Digita il testo",
    "uidTipTitle" : "Proteggi il tuo account con la Verifica OTP",
    "uidTipHowToGet" : "Come ottenere la mia password monouso (OTP)?",
    "uidTipStep1" : "Passaggio 1: vai su Impostazioni > Account > Centro Utenti",
    "uidTipStep2" : "Passaggio 2: Tocca OTP",
    "uidTipstep3" : "Passaggio 3: copia e inserisci il tuo UID e la password monouso (OTP)",
    "uidTipIntro1" : "1. Le password monouso scadono tra 60 secondi. Usale con saggezza per mantenere il tuo account sicuro e protetto.",
    "uidTipIntro2" : "2. Lo staff di non ti chiederà la tua password monouso. Si prega di non condividere o fornire mai la password.",
    "couponMyQuan" : "Buoni",
    "couponSelectPaytypeTip" : "Seleziona il canale di pagamento per vedere le informazioni sullo sconto",
    "couponSelectCouponTip" : "Seleziona i buoni per vedere il prezzo scontato",
    "couponValidQuanTip" : "(Buono x\${num} utilizzabile)",
    "couponLookCart" : "Carrello",
    "couponUnfoldCart" : "Nascondi",
    "couponCoupon" : "Coupon",
    "couponNoUse" : "Non utilizzando",
    "couponSelect" : "Seleziona coupon",
    "couponSureUse" : "Usa",
    "couponReturn" : "Indietro",
    "couponInvalidTime" : "Scade",
    "couponBuyNow" : "Acquista Ora",
    "couponAllType" : "all",
    "ztmslgType1" : "Vendita Giornaliera",
    "ztmslgType2" : "Eroe",
    "ztmslgType3" : "Equip. Battaglia",
    "ztmslgType4" : "",
    "ztmslgType5" : "Chip",
    "ztmslgType6" : "Nova",
    "ztmslgType7" : "Risorse",
    "ztmslgType8" : "Velocizz. Costruzione",
    "ztmslgType9" : "Oggetti Rari",
    "ztmslgType10" : "Alleanza",
    "ztmslgType11" : "Diamante",
    "ztmslgType12" : "Modulo",
    "ztmslgType13" : "Cubo",
    "ztmslgType14" : "",
    "ztmslgType15" : "Nanoarma",
    "ztmslgType16" : "Premio Finale",
    "ztmslgType17" : "Nucleo",
    "ztmslgType9999" : "Offerta Limitata",
    "ztmslgType10000" : "Centro Regali",
    "ztmslgType10001" : "Eventi Festività",
    "ztmslgTypeother" : "Other",
    "antslgType1" : "Vendita Giornaliera",
    "antslgType2" : "Formica Specializzata",
    "antslgType3" : "Equipaggiamento",
    "antslgType5" : "Gene",
    "antslgType6" : "Lumaca",
    "antslgType7" : "Risorse",
    "antslgType8" : "Costruisci & Ricerca",
    "antslgType9" : "Oggetti Rari",
    "antslgType10" : "Alleanza",
    "antslgType11" : "Diamante",
    "antslgType12" : "Cellula",
    "antslgType13" : "Totem",
    "antslgType9999" : "Offerta Limitata",
    "antslgTypeother" : "other",
    "typeall" : "Tutti",
    "vipHead" : "Punti VIP",
    "vipHead213": "Abbonamento Premium",
    "vipTitle" : "Evento Punti VIP",
    "nowLevel" : "Il tuo livello:",
    "myVipScore" : "I tuoi pti:",
    "nextLevelNeed" : "(Guadagna \${num} punti in più per ottenere VIP \${level})",
    "ruleTitle" : "Regole:",
    "ztmslgVipRule1" : "1. L’evento inizia alle 00:00 (UTC) 2022/09/22",
    "ztmslgVipRule2" : "2. Giochi disponibili:  Puzzles & Survival",
    "ztmslgVipRule3" : "Ogni tipo di ricompensa d’evento può essere rivendicata solo una volta.",
    "ztmslgVipRule4" : "3. Evento Buono Accesso: quando accedi per la prima volta alla pagina di ricarica, potrai richiedere un buono che offre uno sconto del 15%.",
    "ztmslgVipRule5" : "4. Evento Punti VIP: acquista oggetti tramite il nostro sito ufficiale per guadagnare punti ed ottenere buoni livello e buoni settimanali.",
    "ztmslgVipRule6" : "5. I punti che potresti guadagnare potrebbero variare in base alla valuta che stai usando. Per ulteriori dettagli, ti invitiamo a verificare il link in fondo.",
    "ztmslgVipRule7" : "6. Quando utilizzi i coupon, guadagnerai punti in base all\'importo che hai pagato dopo che i coupon sono stati detratti.",
    "ztmslgVipRule8" : "7. I punti che hai accumulato scadranno tra 365 giorni. Questo potrebbe influenzare il tuo livello VIP.",
    "ztmslgVipRule9" : "8. Riceverai immediatamente un coupon per raggiungere per la prima volta un livello VIP. Il coupon settimanale sarà riscuotibile alle 00:00 (UTC+0) di ogni Sabato.",
    "ztmslgVipRule10" : "9. Dovrai effettuare l’accesso per richiedere il buono settimanale. Da non perdere!",
    "ztmslgVipRule11" : "10. La valuta del coupon sarà la valuta dell\'ultimo ordine che hai effettuato. Contatta il nostro servizio clienti se desideri cambiare la valuta che stai utilizzando.",
    "ztmslgVipRule12" : "11. Consulta la tabella seguente per maggiori dettagli sui livelli VIP e sui coupon.",
    "ztmslgVipRule13" : "12. In caso di qualsiasi controversia, il team di supporto di Puzzles & Survival ha la sola e ultima discrezione di interpretazione di questi Termini e Condizioni.",
    "vipLevel" : "Livello VIP",
    "vipCondition" : "Pti richiesti",
    "firstSend" : "Prima volta che si raggiunge il regalo",
    "weeklySend" : "Coupon settimanale",
    "lastAllCoupon" : "Buoni di livello precedente",
    "besides" : "Valuta/Tabella Punti:",
    "couponRatio" : "Valuta/Tasso Punti",
    "backToPay" : "INDIETRO",
    "quanGift" : "COUPON",
    "quanGiftTips" : "Hai buono(i) rivendicabili!",
    "antslgVipRule1": "A causa di un aggiornamento delle funzionalità, l'evento \"Punti VIP\" verrà presto interrotto.",
    "antslgVipRule2": "Assicuratevi di usare i buoni ottenuti dall'evento \"Punti VIP\" prima che scadano.",
    "antslgVipRule3": "Ora d'Interruzione: 28/09/2024 00:00:00 (UTC)",
    "antslgVipRule4": "Dopo la fine dell'evento, potrai visitare il Centro Abbonamento Premium per usufruire di ulteriori vantaggi:",
    "antslgVipRule5": "Completa le missioni per guadagnare punti, che possono essere scambiati con buoni, oggetti di gioco e altre ricompense! Goditi vantaggi esclusivi per i membri ed estrazioni fortunate.",
    "antslgVipRule6": "Restate sintonizzati per scoprire altre ricompense ed eventi!",
    "dzgVipRule0" : "1. L’evento inizia alle 00:00 (UTC) 2022/09/27",
    "dzgVipRule1" : "1. Giochi disponibili:  \${gameName}",
    "dzgVipRule2" : "Ogni tipo di ricompensa d’evento può essere rivendicata solo una volta.",
    "dzgVipRule3" : "2. Evento Buono Accesso: quando accedi per la prima volta alla pagina di ricarica, potrai richiedere un buono che offre uno sconto del 15%.",
    "dzgVipRule4" : "3. Evento Punti VIP: acquista oggetti tramite il nostro sito ufficiale per guadagnare punti ed ottenere buoni livello e buoni settimanali.",
    "dzgVipRule5" : "4. I punti che potresti guadagnare potrebbero variare in base alla valuta che stai usando. Per ulteriori dettagli, ti invitiamo a verificare il link in fondo.",
    "dzgVipRule6" : "5. Quando utilizzi i coupon, guadagnerai punti in base all\'importo che hai pagato dopo che i coupon sono stati detratti.",
    "dzgVipRule7" : "6. I punti che hai accumulato scadranno tra 365 giorni. Questo potrebbe influenzare il tuo livello VIP.",
    "dzgVipRule8" : "7. Riceverai immediatamente un coupon per raggiungere per la prima volta un livello VIP. Il coupon settimanale sarà riscuotibile alle 00:00 (UTC+0) di ogni Sabato.",
    "dzgVipRule9" : "8. Dovrai effettuare l’accesso per richiedere il buono settimanale. Da non perdere!",
    "dzgVipRule10" : "9. La valuta del coupon sarà la valuta dell\'ultimo ordine che hai effettuato. Contatta il nostro servizio clienti se desideri cambiare la valuta che stai utilizzando.",
    "dzgVipRule11" : "10. Consulta la tabella seguente per maggiori dettagli sui livelli VIP e sui coupon.",
    "dzgVipRule12" : "11. In caso di qualsiasi controversia, il team di supporto di \${gameName} ha la sola e ultima discrezione di interpretazione di questi Termini e Condizioni.",
    "213dzgVipRule1" : "A causa di un aggiornamento delle funzionalità, l'evento \"Punti VIP\" verrà presto interrotto.",
    "213dzgVipRule2" : "Assicuratevi di usare i buoni ottenuti dall'evento \"Punti VIP\" prima che scadano.",
    "213dzgVipRule3" : "Ora d'Interruzione: 19/08/2024 08:00:00 (UTC)",
    "213dzgVipRule4" : "Dopo la fine dell'evento, potrai visitare il Centro Abbonamento Premium per usufruire di ulteriori vantaggi:",
    "213dzgVipRule5" : "Completa le missioni per guadagnare punti, che possono essere scambiati con buoni, oggetti di gioco e altre ricompense! Goditi vantaggi esclusivi per i membri ed estrazioni fortunate.",
    "213dzgVipRule6" : "Restate sintonizzati per scoprire altre ricompense ed eventi!",
    "getReward" : "Exclusive avatar frames",
    "unbindEntry" : "Associa/Scollega Account",
    "unbindApply" : "Scollega",
    "unbindConfirmTitle" : "Sei sicuro di voler scollegare l’account?",
    "unbindConfirmTip" : "Scollegare l’account potrebbe comportare una perdita di salvataggio/progresso del gioco.",
    "unbindConfirm" : "Scollega comunque",
    "unbindExit" : "Esci",
    "unbindSucc" : "Account scollegato",
    "unbindFail" : "Impossibile scollegare il tuo account. Si prega di contattare il nostro servizio clienti.",
    "unbindServiceTitle" : "Si prega di presentare un\'operazione di scollegamento manuale.",
    "unbindContact" : "Servizio Clienti",
    "unbindServiceTip" : "Non puoi scollegare il tuo account. Si prega di contattare il nostro servizio clienti.",
    "antslgType15" : "Eredità",
    "shareEventTitle" : "Invita Amici</br>Ottieni Ricompense",
    "shareRule" : "Regole",
    "awardBag" : "La Mia Ricompensa",
    "initiatorText" : "Sono un Invitante",
    "inviteeText" : "Sono un Invitato",
    "createCode" : "Crea Codice Invito",
    "createCodeTip" : "Tocca per creare un codice invito",
    "createLinkTip" : "Tocca per creare un link invito",
    "copyText" : "Copia",
    "shareCode" : "Condividi Codice Invito",
    "twShare" : "",
    "fbShare" : "",
    "dcShare" : "",
    "seeAward" : "Visualizza Ricompensa",
    "seeAwardTip" : "Si prega di controllare le tue ricompense in <span class=\"see-light\">Punti VIP</span> > <span class=\"see-light\">I Miei Coupon</span>.",
    "inviteReward" : "Ricompensa Invito",
    "inviteRewardTip" : "L\'invitante può richiedere i premi solo quando ogni invitato ha raggiunto questi obiettivi per la prima volta",
    "overweightReward" : "Ricompensa Bonus",
    "resetTip" : "Si ripristina alle 00:00 all’ultimo giorno di ogni mese.",
    "rewardText1" : "Ricarica totale dall’invitato: \$9.99",
    "rewardText2" : "Ricarica totale dall’invitato: \$49.99",
    "rewardText3" : "Ricarica totale dall’invitato: \$99.99",
    "rewardText4" : "Ottieni Coupon SCONTO 12% x1 per Ogni 5 Giocatori Invitati",
    "rewardText5" : "Ottieni Coupon SCONTO 15% Dopo che i Tuoi Invitati Ricaricano un Totale di \$1,000",
    "invitationList" : "Il Mio Invito",
    "refresh" : "Aggiorna",
    "invitedTotal" : "Invitato: \${total}",
    "storedTotal" : "Ricarica Totale: \${total} USD",
    "people" : "",
    "invitedPeople" : "Invitato",
    "invitedTime" : "Invitato",
    "got" : "Raggiunto",
    "get" : "Non Ottenuto",
    "overlay" : "Accumulabile",
    "couponText" : "Coupon",
    "personalReward" : "Ricompensa Ricarica",
    "personalRewardText1" : "Ricarica Totale Raggiunge \$9.99",
    "personalRewardText2" : "Ricarica Totale Raggiunge \$49.99",
    "personalRewardText3" : "Ricarica Totale Raggiunge \$99.99",
    "inputCode" : "Inserisci Codice Invito",
    "bindCode" : "Conferma",
    "bindSucc" : "Associato",
    "codeTip1" : "Il codice non esiste.",
    "codeTip2" : "Codice Invito Associato",
    "copySucc" : "Successo!",
    "awardName" : "Ricompensa",
    "getTime" : "Ottenuto",
    "getCondition" : "Requisito",
    "couponText1" : "Coupon SCONTO 6%",
    "couponText2" : "Coupon SCONTO 8%",
    "couponText3" : "Coupon SCONTO 10%",
    "couponText4" : "Coupon SCONTO 12%",
    "couponText5" : "Coupon SCONTO 15%",
    "ruleText1" : "1. Orario inizio evento: 2022/11/25, 00:00 UTC",
    "ruleText2" : "2. Gioco evento: Puzzles & Survival",
    "ruleText3" : "3. Evento \"Condivisione sito ufficiale di ricarica\": condividi questo sito ufficiale di ricarica con i tuoi amici e invitali a ricaricare.  Se ricaricano un determinato importo tramite questa pagina, sarai ricompensato.",
    "ruleText4" : "4. Premi mensili da pagamento di terze parti: raggiungi obiettivi di condivisione mensili per vincere premi. I premi di condivisione vengono ripristinati ogni mese.",
    "ruleText5" : "5. I premi mensili richiedono almeno un pagamento di ricarica riuscito sul sito di terze parti da parte dei nuovi giocatori che hai invitato.",
    "ruleText6" : "6. I premi mensili si azzerano il primo giorno di ogni mese.  In questo modo vengono ripristinati anche eventuali progressi rispetto al mese precedente.",
    "ruleText7" : "7. Il coupon ricompensato deve essere richiesto accedendo al sito di ricarica di terze parti.  Non riceverai un altro coupon se è scaduto.",
    "ruleText8" : "8. Il coupon utilizza la stessa valuta che hai utilizzato nelle precedenti ricariche riuscite.",
    "ruleText9" : "9. Non puoi utilizzare il codice di invito di un altro giocatore se ha già utilizzato il tuo.",
    "ruleTableTitle1" : "Regole：",
    "ruleTableTitle2" : "Livelli VIP e Coupon Spiegati:",
    "ruleTableHead1" : "Requisito Ricarica",
    "ruleTableHead2" : "Requisito Ricompense",
    "ruleTableHead3" : "Ricompense",
    "ruleTableContent1" : "Invita 5 nuovi giocatori",
    "ruleTableContent2" : "Ricarica giocatori invitati di \$1,000 USD",
    "errorTip" : "Operazione Fallita",
    "eventShareText1" : "Offerte a Tempo Limitato Puzzles & Survival",
    "eventShareText2" : "Un Sacco di Regali Ti Aspettano!",
    "cartDoubleTip" : "Moltiplicatori Scatola non sono supportati.",
    "codeTip3" : "Accesso non effettuato",
    "codeTip4" : "Parametro mancante",
    "codeTip5" : "Impossibile associare il tuo proprio codice invito",
    "codeTip6" : "Codice Invito creato",
    "payWelfare" : "Regalo Riempimento",
    "wallet" : "Portafoglio",
    "myDiscount" : "Il Mio Coupon",
    "knowMore" : "Più",
    "backPay" : "Indietro",
    "curBalance" : "Saldo",
    "pay" : "Ricarica",
    "changeCoin" : "Cambia Valuta",
    "watchDesc" : "Visualizza Dettagli",
    "getMore" : "Ottieni di più",
    "getDiscount" : "Rivendica i tuoi Coupon",
    "notOpenDiscountQuan" : "Nessun evento. Rimani sintonizzato!",
    "abountZbit" : "Info su \${Z-BIT}",
    "remain" : "Rimasto:",
    "payRemain" : "Quantità rimasta dopo l’acquisto:",
    "balanceNotEnoggh" : "Non abbastanza saldo. Si prega di ricaricare prima.",
    "goToPay" : "Ricarica",
    "chooseOtherPay" : "Altri Metodi di Pagamento",
    "payIntro" : "Dettagli Ricarica",
    "logRole" : "Seleziona Personaggio",
    "chooseProduct" : "Seleziona Oggetti",
    "meAgree" : "Ho letto e accetto i termini.",
    "coinAgreeText" : "",
    "aboutCoin" : "",
    "coinsPayTokenLogin" : "Prima di utilizzare \${Z-BIT} è richiesta la verifica dinamica",
    "dl3dvnVipRule1" : "1. Giochi disponibili:  \${gameName}",
    "dl3dvnVipRule2" : "Ogni tipo di ricompensa d’evento può essere rivendicata solo una volta.",
    "dl3dvnVipRule3" : "2. Evento Buono Accesso: quando accedi per la prima volta alla pagina di ricarica, potrai richiedere un buono che offre uno sconto del 15%.",
    "dl3dvnVipRule4" : "3. Evento Punti VIP: acquista oggetti tramite il nostro sito ufficiale per guadagnare punti ed ottenere buoni livello e buoni settimanali.",
    "dl3dvnVipRule5" : "4. I punti che potresti guadagnare potrebbero variare in base alla valuta che stai usando. Per ulteriori dettagli, ti invitiamo a verificare il link in fondo.",
    "dl3dvnVipRule6" : "5. Quando utilizzi i coupon, guadagnerai punti in base all\'importo che hai pagato dopo che i coupon sono stati detratti.",
    "dl3dvnVipRule7" : "6. I punti che hai accumulato scadranno tra 365 giorni. Questo potrebbe influenzare il tuo livello VIP.",
    "dl3dvnVipRule8" : "7. Riceverai immediatamente un coupon per raggiungere per la prima volta un livello VIP. Il coupon settimanale sarà riscuotibile alle 00:00 (UTC+0) di ogni Sabato.",
    "dl3dvnVipRule9" : "8. Dovrai effettuare l’accesso per richiedere il buono settimanale. Da non perdere!",
    "dl3dvnVipRule10" : "9. La valuta del coupon sarà la valuta dell\'ultimo ordine che hai effettuato. Contatta il nostro servizio clienti se desideri cambiare la valuta che stai utilizzando.",
    "dl3dvnVipRule11" : "10. Consulta la tabella seguente per maggiori dettagli sui livelli VIP e sui coupon.",
    "dl3dvnVipRule12" : "",
    "dl3dvnVipRule13" : "12. In caso di qualsiasi controversia, il team di supporto di \${gameName} ha la sola e ultima discrezione di interpretazione di questi Termini e Condizioni.",
    "codeTip7" : "Impossibile utilizzare il codice del giocatore di destinazione poiché hanno già utilizzato il tuo",
    "ruleText10" : "10. La direzione ufficiale di Puzzles & Survival si riserva ogni diritto per l\'interpretazione finale.",
    "payCoins" : "Ricarica Punti VIP",
    "shareGift" : "Condividi per Regali",
    "attentionCoinUse" : "Note: The balance in each currency is handled separately.",
    "noPayWay" : "non ci sono metodi di pagamento disponibili nella regione selezionata. si prega di cambiare la regione e riprovare.",
    "dl3dtwVipRule1" : "1. Giochi disponibili:  \${gameName}",
    "dl3dtwVipRule2" : "Ogni tipo di ricompensa d’evento può essere rivendicata solo una volta.",
    "dl3dtwVipRule3" : "2. Evento Punti VIP: acquista oggetti tramite il nostro sito ufficiale per guadagnare punti ed ottenere buoni livello e buoni settimanali.",
    "dl3dtwVipRule4" : "3. I punti che potresti guadagnare potrebbero variare in base alla valuta che stai usando. Per ulteriori dettagli, ti invitiamo a verificare il link in fondo.",
    "dl3dtwVipRule5" : "4. Quando utilizzi i coupon, guadagnerai punti in base all\'importo che hai pagato dopo che i coupon sono stati detratti.",
    "dl3dtwVipRule6" : "5. I punti che hai accumulato scadranno tra 365 giorni. Questo potrebbe influenzare il tuo livello VIP.",
    "dl3dtwVipRule7" : "6. Riceverai immediatamente un coupon per raggiungere per la prima volta un livello VIP. Il coupon settimanale sarà riscuotibile alle 00:00 (UTC+0) di ogni Sabato.",
    "dl3dtwVipRule8" : "7. Dovrai effettuare l’accesso per richiedere il buono settimanale. Da non perdere!",
    "dl3dtwVipRule9" : "8. La valuta del coupon sarà la valuta dell\'ultimo ordine che hai effettuato. Contatta il nostro servizio clienti se desideri cambiare la valuta che stai utilizzando.",
    "dl3dtwVipRule10" : "9. Consulta la tabella seguente per maggiori dettagli sui livelli VIP e sui coupon.",
    "dl3dtwVipRule11" : "10. In caso di qualsiasi controversia, il team di supporto di \${gameName} ha la sola e ultima discrezione di interpretazione di questi Termini e Condizioni.",
    "eventInviteSucc" : "Invita Con Successo Un Amico",
    "eventGainCondition" : "Requisiti",
    "eventSuccInvite" : "Invita con successo un amico",
    "eventInviteGainOne" : "Ricarica Totale\nDall\'Invitato: \$49.99",
    "eventInviteGainTwo" : "Ricarica Totale\nDall\'Invitato: \$99.99",
    "eventFriendCode" : "Il Codice del Tuo Amico:",
    "eventCheckBind" : "Associa?",
    "eventConfirm" : "Conferma",
    "eventCancel" : "Cancella",
    "eventBindSucc" : "Associato con successo! Hai",
    "eventGainCoupon" : "ottenuto un buono.",
    "eventLookCoupon" : "Visualizza Buono",
    "eventSuccBind" : "Associato con successo",
    "recaptchaTip" : "Si prega di verificare prima",
    "inputAccountName" : "Inserisci l\'account che desideri recuperare",
    "pwaPayTip" : "Accesso Rapido, Esperienza Migliore",
    "pwsInstall" : "Aggiungi alla schermata Home",
    "ztmslgType999" : "Voucher",
    "coinUseTips" : "Al momento dell\'acquisto, i Buoni verranno inviati alla tua casella di posta all\'interno del gioco. I Buoni possono essere utilizzati per acquistare oggetti dal Centro Commerciale dei Buoni all\'interno del gioco. I Buoni utilizzati per l\'acquisto di oggetti verranno conteggiati per la ricarica totale.",
    "notice" : "Avviso",
    "popupConfirm" : "Conferma",
    "hideWithinWeek" : "Non mostrare più per 7 giorni",
    "ztmslgProductOffTips" : "Abbiamo ricevuto molti feedback in merito alle modifiche alla pagina di pagamento che dovevano essere implementate il 13 Marzo. In risposta a ciò, abbiamo deciso di annullare queste modifiche e ci concentreremo sul miglioramento della tua esperienza di acquisto. Apprezziamo le vostre opinioni e vi ringraziamo per la comprensione e il supporto. Se hai ulteriori domande, non esitare a contattare il nostro team di Assistenza Clienti.",
    "couponTopLimit" : "Quantità Massima Deducibile per Valuta",
    "swsjpVipRule1" : "1. L’evento inizia alle 00:00 (UTC) 2023/03/24",
    "swsjpVipRule2" : "2. Giochi disponibili: \${gameName}",
    "swsjpVipRule3" : "Ogni tipo di ricompensa d’evento può essere rivendicata solo una volta.",
    "swsjpVipRule4" : "3. Evento Buono Accesso: quando accedi per la prima volta alla pagina di ricarica, potrai richiedere un buono che offre uno sconto del 15%.",
    "swsjpVipRule5" : "4. Evento Punti VIP: acquista oggetti tramite il nostro sito ufficiale per guadagnare punti ed ottenere buoni livello e buoni settimanali.",
    "swsjpVipRule6" : "5. I punti che potresti guadagnare potrebbero variare in base alla valuta che stai usando. Per ulteriori dettagli, ti invitiamo a verificare il link in fondo.",
    "swsjpVipRule7" : "6. Quando utilizzi i coupon, guadagnerai punti in base all\'importo che hai pagato dopo che i coupon sono stati detratti.",
    "swsjpVipRule8" : "7. Ti vengono già assegnati punti per gli acquisti effettuati in precedenza.",
    "swsjpVipRule9" : "8. I punti che hai accumulato scadranno tra 365 giorni. Questo potrebbe influenzare il tuo livello VIP.",
    "swsjpVipRule10" : "9. Riceverai immediatamente un coupon per raggiungere per la prima volta un livello VIP. Il coupon settimanale sarà riscuotibile alle 00:00 (UTC+0) di ogni Sabato.",
    "swsjpVipRule11" : "10. Dovrai effettuare l’accesso per richiedere il buono settimanale. Da non perdere!",
    "swsjpVipRule12" : "11. La valuta del coupon sarà la valuta dell\'ultimo ordine che hai effettuato. Contatta il nostro servizio clienti se desideri cambiare la valuta che stai utilizzando.",
    "swsjpVipRule13" : "12. In caso di qualsiasi controversia, il team di supporto di \${gameName} ha la sola e ultima discrezione di interpretazione di questi Termini e Condizioni.",
    "beautyVipRule1" : "",
    "beautyVipRule2" : "",
    "beautyVipRule3" : "",
    "beautyVipRule4" : "",
    "beautyVipRule5" : "",
    "beautyVipRule6" : "",
    "beautyVipRule7" : "",
    "beautyVipRule8" : "",
    "beautyVipRule9" : "",
    "beautyVipRule10" : "",
    "beautyVipRule11" : "",
    "antslgType999" : "Buono",
    "passAskMods" : "Chiedi ad un Moderatore",
    "passAskModsTip" : "Poni ai moderatori qualsiasi domanda riguardante il gioco",
    "passService" : "Domanda del Cliente",
    "passServiceTip" : "Per qualsiasi domanda relativa al conto e alla ricarica, contatta il nostro servizio clienti.",
    "passIKonw" : "OK",
    "passGoOn" : "Continua",
    "voucherTitle" : "Centro di Ricarica Ufficiale",
    "voucherAddHome" : "Aggiungi al Desktop",
    "voucherAddHomeTipOne" : "Pagamenti Più Veloci, Miglior Esperienza",
    "voucherAddHomeTipTwo" : "Tocca [Condividi] nella barra degli strumenti",
    "voucherAddHomeTipThree" : "Seleziona [Aggiungi al Desktop]",
    "voucherLoginLook" : "Accedi per visualizzare le offerte",
    "voucherSwitchRole" : "Cambia Personaggio",
    "voucherCoupon" : "Buono",
    "voucherVip" : "Punto VIP",
    "voucherMoreCoupon" : "Altre Offerte",
    "voucherAccountId" : "ID Account",
    "voucherOtp" : "OTP",
    "voucherOtherWayPay" : "Scegli un altro metodo di pagamento",
    "voucherOtherLoginWay" : "Prova un altro modo",
    "voucherCouponActivity" : "Sconti",
    "voucherActivityNotBegin" : "Evento non ancora iniziato.",
    "voucherGoCommunity" : "Scopri di più sui vantaggi del ricaricamento nella community",
    "voucherValidTime" : "Validità",
    "voucherLimitRegion" : "Solo per \${currency}",
    "voucherLiuyi" : "Nessun buono disponibile. Prestare attenzione a future offerte.",
    "voucherPay" : "Acquista Buoni",
    "voucherAbout" : "Informazioni sul Buono",
    "voucherChooseWay" : "Seleziona il Metodo di Pagamento",
    "voucherMoreWay" : "Altri Metodi di Pagamento",
    "voucherChooseCoupon" : "Seleziona Buono",
    "voucherHasChoose" : "Selezionato",
    "voucherMoneyInsufficient" : "Saldo insufficiente",
    "voucherContact" : "Saldo insufficiente. Si prega di contattare il nostro team di supporto.",
    "voucherCouponTotal" : "Buoni Disponibili",
    "voucherCouponTipGuide" : "I buoni possono essere utilizzati per il pagamento dopo aver selezionato il canale di pagamento.",
    "voucherPaytypeNotSupport" : "I buoni non sono disponibili per questo canale di pagamento",
    "voucherTipSideOne" : "I buoni possono essere scambiati con tutti i pacchetti in-game e i servizi a valore aggiunto, ad eccezione del buono stesso.",
    "voucherTipSideTwo" : "Fino al 15% di sconto",
    "voucherYue" : "Bilancio",
    "jpUidLoginName" : "",
    "jpUidToken" : "",
    "jpUidInputToken" : "",
    "pnsBook" : "Manuale di Sopravvivenza",
    "vipHeadText" : "Cornice VIP esclusiva sbloccata",
    "vipHeadGetText" : "Rivendica",
    "vipHeadGotText" : "Rivendicato",
    "vipHeadGetTitle" : "Conferma",
    "vipHeadGetTip" : "Questa ricompensa può essere rivendicata solo una volta per account.",
    "vipHeadAwardText" : "Comandante Elite (Permanente)",
    "vipHeadGetErrTip1" : "Fallito. Riprova o contatta il SC.",
    "cartGuideTipNew" : "Aggiungi più oggetti per usare il buono",
    "newVipTitle" : "Centro di Ricarica VIP",
    "newVipLogin" : "ACCEDI",
    "newVipNowPoint" : "Punti:",
    "newVipNextLevel" : "\${point} punti al prossimo livello",
    "newVipUpgrade" : "MIGLIORA",
    "newVipLevel" : "Privilegi VIP",
    "newVipTip" : "I buoni verranno aggiornati alle 00:00 (UTC) ogni Sabato. Li riceverai quando accedi alla pagina di ricarica ufficiale.",
    "newVipWeekly" : "Regalo Settimanale",
    "newVipReachPoint" : "Requisiti:",
    "newVipRuleInfo" : "Regole:",
    "pleaseLang" : "Scegli una lingua",
    "reference" : "Numero Ordine",
    "saveToNext" : "Salva i dati della carta di credito.",
    "cardNum" : "Numero Carta",
    "expireTime" : "Valida fino al",
    "CVV" : "CVV",
    "pleaseCard" : "Tipologia carta di credito",
    "howToPay" : "Come vorresti pagare?",
    "checkCard" : "Controlla il numero della tua carta.",
    "checkExpiryDate" : "Controlla la data di scadenza della tua carta.",
    "checkCVV" : "Controlla il CVV della tua carta.",
    "addCard" : "Nuovo",
    "delete" : "Cancella",
    "deleteCardTips" : "Elimina i dati della carta di credito salvata.",
    "confirmDelete" : "Sì, cancella",
    "cancelDelete" : "Annulla",
    "checkAllCardMsg" : "Assicurati di aver inserito il numero di carta, la data di scadenza e il CVV corretti.",
    "leaveCreditPageTips" : "Bu sayfadan şimdi çıkarsan, işlem tamamlanmayacak. Yine de çık?",
    "sureToLeave" : "Çık",
    "continueToPay" : "Devam Et",
    "pushTest" : "Test Notifica",
    "getNoticication" : "Non ricevi notifiche di gioco?",
    "waitCheckResult" : "Si prega di attendere il risultato del test.",
    "hadAbnormal" : "Rilevata anomalia che potrebbe portare all\'errore di notifica.",
    "clickIntro" : "Tocca il rapporto per vedere la soluzione",
    "networkCheck" : "Test di rete",
    "noticeAuthorityCheck" : "Test accesso notifica",
    "noticeBtnCheck" : "Test della barra delle notifiche",
    "gmsCheck" : "Prova di servizio GMS",
    "batteryCheck" : "Test dell\'elenco di ottimizzazione della batteria",
    "pushServiceCheck" : "Test del servizio di notifica",
    "reCheck" : "Prova di Nuovo",
    "noNoticeAuthorityTip" : "Accesso alle notifiche non concesso su questo dispositivo. Vai su Impostazioni di Sistema - Notifiche per concedere l\'accesso al gioco.",
    "noNoticeBtnTip" : "La barra delle notifiche è disattivata. Si prega di attivarla in Impostazioni di Sistema.",
    "noBatteryTip" : "Il gioco è nell\'elenco di ottimizzazione della batteria, potresti non ricevere le notifiche. Vai su Impostazioni di Sistema - Batteria - Ottimizzazione Batteria per aggiungere il gioco alla lista bianca (whitelist).",
    "noPushServiceTip" : "Server di notifica non connesso. Toccare [Connetti] per riprendere il servizio.",
    "noNetworkTip" : "La tua attuale connessione di rete è instabile.",
    "noGmsTip" : "Il tuo dispositivo non supporta GMS. Utilizza un dispositivo compatibile con GMS.",
    "pushConnectFail" : "Server di notifica disconnesso.",
    "pushConnectSucc" : "Server di notifica connesso.",
    "noGetPushTitle" : "Se non riesci ancora a ricevere notifiche dal gioco. Si prega di seguire questi passaggi:",
    "noGetPushContOne" : "1. Esci dal gioco e accedi nuovamente su questo dispositivo.",
    "noGetPushContTwo" : "2. Tocca [Test di notifica] per verificare se il tuo dispositivo attualmente in uso può ricevere la notifica di prova.",
    "noGetPushContThree" : "3. Se hai ricevuto la notifica del test ma non riesci ancora a ricevere altre notifiche, accedi al gioco, vai su Impostazioni - Notifiche e controlla se tutte le notifiche sono attivate.",
    "noGetPushContFour" : "4. Se non riesci ancora a ricevere alcuna notifica, contatta il nostro servizio clienti.",
    "getPushSucc" : "Il tuo dispositivo ha ricevuto una notifica di prova. La funzione funziona normalmente!",
    "allCheckSucc" : "Test di notifica effettuato. Non viene rilevata alcuna anomalia!",
    "pushCheck" : "Test notifica",
    "useDirectPay" : "Usa Pagamento Rapido",
    "paypalFraudnetInfo" : "Pagamento sicuro tramite PayPal",
    "goToSetting" : "Impostazioni",
    "retry" : "Riprova",
    "connect" : "Connetti",
    "canRebind" : "Puoi associare di nuovo dopo aver scollegato",
    "agreePlatform" : "Ho accettato il \${service} e il \${privite}.",
    "sendGameNews" : "Iscriviti alle newsletter.",
    "canNotBindEmail" : "Non sarai in grado di utilizzare questa e-mail per accedere una volta che l\'hai scollegata.",
    "canNotBindPhone" : "Non sarai in grado di utilizzare questo numero di cellulare per accedere una volta che lo avrai scollegato.",
    "canChangeByEmail" : "Puoi accedere con e-mail su diversi dispositivi.",
    "canChangeByPhone" : "Puoi accedere con il numero di cellulare su diversi dispositivi.",
    "loginSucc" : "Accesso effettuato",
    "phoneHadBind" : "Il numero di cellulare è già stato associato. Accedi con esso?",
    "emailHadBind" : "L\'E-mail è già stata associata. Accedi con essa?",
    "phoneNotBind" : "Il numero di cellulare non è stato ancora associato. Creare un nuovo account?",
    "emailNotBind" : "L\'email non è stata ancora associata. Creare un nuovo account?",
    "emailAccount" : "E-mail Account",
    "phoneAccount" : "Cellulare Account",
    "phoneInputError" : "Numero di cellulare non valido",
    "registerNewAccount" : "Iscriviti",
    "secureTip" : "Suggerimenti per la sicurezza dell\'account",
    "toTop" : "Fissa in alto",
    "createNewWork" : "Nuovo Ticket",
    "serviceEvaluate" : "Valuta Servizio",
    "emailRemind" : "Notifiche",
    "isAgreeService" : "Come ti piace il nostro servizio?",
    "thankEvaluateTop" : "Grazie per il tuo feedback!",
    "inputValidEmail" : "Si prega di inserire un indirizzo email valido.",
    "replyWillRemind" : "Riceverai un\'e-mail di notifica quando verrà data risposta alla tua domanda. Tocca di nuovo per disattivarlo.",
    "isCancelEmailRemind" : "Non riceverai alcuna email di notifica. Disattivare comunque?",
    "reconfirmEmail" : "Conferma il tuo indirizzo email.",
    "confirmCanSubmit" : "Conferma per inviare il ticket",
    "serviceWillReply" : "Riceverai una notifica via e-mail quando il servizio clienti avrà risposto.",
    "cancelEmailRemind" : "Disattiva le [Notifiche]?",
    "yes" : "Sì",
    "no" : "No",
    "inputWorkSearch" : "Cerca...",
    "loading" : "Caricando",
    "loadingError" : "Caricamento fallito. Per favore carica di nuovo...",
    "noMore" : "Niente di più",
    "cancelToTop" : "Rimuovi",
    "evaluateOne" : "Pessimo",
    "evaluateTwo" : "Cattivo",
    "evaluateThree" : "Neutrale",
    "evaluateFour" : "Buono",
    "evaluateFive" : "Ottimo",
    "confirmDelWorkTop" : "Eliminare questo ticket?",
    "reRemindEmail" : "Hai bisogno di una notifica tramite posta? Basta toccare nuovamente il pulsante [Notifiche].",
    "confirmWillReply" : "Conferma per accettare di essere avvisato via e-mail quando il servizio clienti avrà risposto.",
    "thankEvaluateBottom" : "",
    "confirmDelWorkBottom" : "Non è possibile recuperare un ticket eliminato.",
    "morePurchaseWay" : "",
    "purchaseNeed" : "",
    "videoUploadSucc" : "Video caricato",
    "videoUploadFail" : "Impossibile caricare il video",
    "videoUploadLimit" : "Carica un file mp4 con dimensioni inferiori a 400 MB e non più lunghi di 2 minuti.",
    "imageUploadSucc" : "Immagine caricata",
    "imageUploadFail" : "Impossibile caricare l\'immagine",
    "uploading" : "Caricamento",
    "smartOrderCreate" : "Ticket Rapido",
    "smartOrderSearch" : "Cerca",
    "smartOrderComing" : "Prossimamente",
    "smartOrderContactService" : "Servizio Clienti",
    "smartOrderDetector" : "Assistente",
    "smartOrderDetect" : "Diagnostica",
    "smartOrderDetecting" : "Diagnosi",
    "smartOrderDetectTip" : "È stato rilevato un problema durante il gioco. Tocca Diagnostica in modo che possiamo identificarlo.",
    "smartOrderDetectTip2" : "Problema identificato. Per favore invia un ticket così possiamo risolverlo per te!",
    "smartOrderSubmit" : "Invia",
    "smartOrderIKnow" : "OK",
    "smartOrderConfirm" : "OK",
    "smartOrderLook" : "Visualizza",
    "smartOrderIsHelp" : "Questo articolo è stato utile?",
    "smartOrderInputQuestion" : "Annota il problema che hai riscontrato.",
    "smartOrderPleaseInpt" : "Inserisci",
    "smartOrderPleaseChoose" : "Seleziona",
    "smartOrderStoreTime" : "Tempo Ricarica",
    "smartOrderInputOrder" : "Inserire il numero dell\'ordine",
    "smartOrderInputPrice" : "Inserire l\'importo dell\'ordine",
    "smartOrderNeedHelp" : "Come posso aiutarti?",
    "smartOrderLookHelpTip" : "Puoi consultare le FAQ (Domande più frequenti).",
    "smartOrderNoResult" : "Nessun risultato. Prova un\'altra parola chiave.",
    "smartOrderUpdateTime" : "Ora dell\'ultima modifica",
    "smartOrderSelectStoreTime" : "Seleziona Tempo Ricarica",
    "smartOrderAtlestChoose" : "Per favore, compilane almeno uno",
    "pwaInstallAward" : "Aggiungi Collegamento",
    "getMasonry" : "Rivendica Diamante",
    "addToDrawerVisit" : "Aggiungi un collegamento in modo da poterlo ritrovare facilmente.",
    "immeAddToGet" : "Aggiungi subito il collegamento per richiedere premi limitati.",
    "add" : "Aggiungi Collegamento",
    "talkNextTime" : "Dopo",
    "chooseRoleGetGift" : "Seleziona il tuo personaggio per rivendicare ricompense",
    "getGiftSuccess" : "Rivendicato. Vai a controllare i tuoi premi nel gioco.",
    "dmaTitle" : "Pubblicità Personalizzate",
    "newAdd" : "Nuovo",
    "smartDelete" : "Cancella",
    "wordLengthTip" : "(0-600 caratteri)",
    "areaLimitSwitchRegion" : "Cambia Regione",
    "areaLimitCurrentRegionCurrency" : "Regione e Valuta Attuale",
    "areaLimitRegion" : "Regione:",
    "areaLimitCurrency" : "Valuta:",
    "areaLimitNote" : "Nota:",
    "areaLimitSwitchLimitation" : "Ogni account può cambiare regione una volta ogni anno.",
    "areaLimitPostSwitchCoupon" : "Una volta che la tua regione è cambiata, la valuta dei nuovi buoni cambierà",
    "areaLimitRemainingSwitches" : "Tentativi di cambio rimasti: \${times}",
    "areaLimitNoRemainingSwitches" : "Nessun tentavito di cambio",
    "areaLimitUnableToSwitchThisYear" : "Non puoi cambiare regione di nuovo quest\'anno.",
    "areaLimitCannotSwitch" : "Impossibile Cambiare",
    "areaLimitNavigateToSwitch" : "Cambia",
    "areaLimitConfirmSwitch" : "Conferma",
    "areaLimitPreSwitchRegionCurrency" : "Regione e Valuta Attuale",
    "areaLimitPostSwitchRegionCurrency" : "Nuova Regione e Valuta",
    "areaLimitPostSwitchRestriction" : "Una volta fatto, non puoi cambiare regione di nuovo quest\'anno.",
    "areaLimitUnusedZBitWarning" : "Hai Z-Bit inutilizzati che  potrebbero non essere utilizzabili una volta che cambi regione. Procedere comunque?",
    "areaLimitConfirm" : "Conferma",
    "areaLimitCancel" : "Annulla",
    "areaLimitInconsistencyWarning" : "La tua regione d\'accesso è insonsistente con la regione di pagamento.",
    "areaLimitPromptToSwitch" : "Vuoi cambiare regione?",
    "areaLimitEnterZipCode" : "*Please enter your zipcode",
    "areaLimitEnterInvalid" : "Zipcode is invalid, please re-enter",
    "areaLimitTaxRateTips" : "Depending on your location, the tax rate may vary, the payment amount shall prevail",
    "areaLimitInfoCollect" : "For information collection protection, please refer to the Privacy Policy",
    "getAward" : "Rivendica Ricompensa",
    "selectProductTitle" : "Seleziona Oggetto",
    "hotSuggest" : "Caldo",
    "inputKeywordSearch" : "Cerca...",
    "lookProductContent" : "Dettagli",
    "popupClose" : "Chiudi",
    "productSwitch" : "Cambia",
    "confirmBuy" : "Acquista",
    "thinkLater" : "Dopo",
    "areaLimitConfirmRegion" : "Conferma regione",
    "areaLimitContinuePay" : "Continua a pagare",
    "areaLimitSwitchLimitationTwice" : "Ogni account può cambiare regione due volte ogni anno.",
    "dtmslgVipRule1" : "1. Giochi disponibili:  \${gameName}",
    "dtmslgVipRule2" : "Ogni tipo di ricompensa d’evento può essere rivendicata solo una volta.",
    "dtmslgVipRule3" : "2. Evento Punti VIP: acquista oggetti tramite il nostro sito ufficiale per guadagnare punti ed ottenere buoni livello e buoni settimanali.",
    "dtmslgVipRule4" : "3. I punti che potresti guadagnare potrebbero variare in base alla valuta che stai usando. Per ulteriori dettagli, ti invitiamo a verificare il link in fondo.",
    "dtmslgVipRule5" : "4. Quando utilizzi i coupon, guadagnerai punti in base all\'importo che hai pagato dopo che i coupon sono stati detratti.",
    "dtmslgVipRule6" : "5. I punti che hai accumulato scadranno tra 365 giorni. Questo potrebbe influenzare il tuo livello VIP.",
    "dtmslgVipRule7" : "6. Riceverai immediatamente un coupon per raggiungere per la prima volta un livello VIP. Il coupon settimanale sarà riscuotibile alle 00:00 (UTC+0) di ogni Sabato.",
    "dtmslgVipRule8" : "7. Dovrai effettuare l’accesso per richiedere il buono settimanale. Da non perdere!",
    "dtmslgVipRule9" : "8. La valuta del coupon sarà la valuta dell\'ultimo ordine che hai effettuato. Contatta il nostro servizio clienti se desideri cambiare la valuta che stai utilizzando.",
    "dtmslgVipRule10" : "9. Consulta la tabella seguente per maggiori dettagli sui livelli VIP e sui coupon.",
    "dtmslgVipRule11" : "10. In caso di qualsiasi controversia, il team di supporto di \${gameName} ha la sola e ultima discrezione di interpretazione di questi Termini e Condizioni.",
    "dtmslgType10010" : "Sconto Giornaliero",
    "dtmslgType10020" : "Offerta Limitata",
    "dtmslgType10030" : "Eroe",
    "dtmslgType10040" : "Equipaggiamento",
    "dtmslgType10050" : "Runa",
    "dtmslgType10060" : "Totem",
    "dtmslgType10070" : "Pietra Sacra",
    "dtmslgType10080" : "Drago",
    "dtmslgType10090" : "Risorse",
    "dtmslgType10100" : "Costruzione & Tecnologia",
    "dtmslgType10110" : "Raro",
    "dtmslgType10120" : "Curio",
    "dtmslgType10130" : "Diamante",
    "dtmslgType10140" : "Buono",
    "dtmslgType2" : "Pacchetto Evento",
    "dtmslgType3" : "Centro Ricompense",
    "dtmslgType4" : "Pacchetto Pop-Up",
    "dtmslgType5" : "Pacchetto Schermata Principale",
    "dtmslgType20010" : "Pacchetto Black Friday",
    "dtmslgType20021" : "Regalo 5-Giorni",
    "dtmslgTypeother" : "Other",
    "rightsIntro" : "",
    "213RightsIntro": "A causa di un aggiornamento delle funzionalità, l'evento \"Punti VIP\" verrà presto interrotto.<br/>\n" +
        "Assicuratevi di usare i buoni ottenuti dall'evento \"Punti VIP\" prima che scadano.<br/>\n" +
        "Ora d'Interruzione: 19/08/2024 08:00:00 (UTC)<br/>\n" +
        "Dopo la fine dell'evento, potrai visitare il Centro Abbonamento Premium per usufruire di ulteriori vantaggi:<br/>\n" +
        "Completa le missioni per guadagnare punti, che possono essere scambiati con buoni, oggetti di gioco e altre ricompense! Goditi vantaggi esclusivi per i membri ed estrazioni fortunate.<br/>\n" +
        "Restate sintonizzati per scoprire altre ricompense ed eventi!",
    "263RightsIntro": "A causa di un aggiornamento delle funzionalità, l'evento \"Punti VIP\" verrà presto interrotto.<br/>\n" +
        "Assicuratevi di usare i buoni ottenuti dall'evento \"Punti VIP\" prima che scadano.<br/>\n" +
        "Ora d'Interruzione: 28/09/2024 00:00:00 (UTC)<br/>\n" +
        "Dopo la fine dell'evento, potrai visitare il Centro Abbonamento Premium per usufruire di ulteriori vantaggi:<br/>\n" +
        "Completa le missioni per guadagnare punti, che possono essere scambiati con buoni, oggetti di gioco e altre ricompense! Goditi vantaggi esclusivi per i membri ed estrazioni fortunate.<br/>\n" +
        "Restate sintonizzati per scoprire altre ricompense ed eventi!",
    "goToRights" : "Vai al Centro Membri Premium",
    "oldVipIntro" : "Assicuratevi di usare i buoni ottenuti dall'evento \"Punti VIP\" prima che scadano.",
    "pwa-20001" : "Si prega di eseguire prima l’accesso",
    "pwa-20002" : "Parametro errato",
    "pwa-20003" : "Si prega di designare un personaggio",
    "pwa-20004" : "Impossibile inviare ricompense. Riprova più tardi o contatta il Servizio Clienti.",
    "pwa-20005" : "Hai già richiesto la ricompensa.",
    "pwa-20100" : "L’evento non è iniziato.",
    "pwa-20101" : "L’evento è terminato.",
    "pwa-20102" : "Non puoi ancora rivendicare le ricompense.",
    "pwa-20103" : "Le tue ricompense sono scadute.",
    "pwa-1001" : "Operazione troppo frequente",
    "pwaCommon" : "Riprova più tardi!",
    "zipCodeSwitchZipCode" : "Switch zipcode",
    "zipCodeState" : "state",
    "zipCodeRate" : "rate",
    "-" : "-",
    "officialStore": "Centro di Ricarica Ufficiale",
    "headerSafeTip": "Sicuro e Privo di Rischi Transazione Istantanea",
    "safeChecking": "...scansione dell'ambiente di pagamento attuale",
    "safeChecked": "Sicuro, affidabile da usare",
    "riskChecked": "Rilevato rischio potenziale, procedere con cautela",
    "footerSafeTitle1": "Sicuro",
    "footerSafeTitle2": "Conveniente",
    "footerSafeTitle3": "Economico",
    "footerSafeTitle4": "Efficiente",
    "footerSafeContent1": "Centro di Ricarica Ufficiale",
    "footerSafeContent2": "Supporta più metodi di pagamento",
    "footerSafeContent3": "Offerte di sconto, più vantaggi limitati nel tempo",
    "footerSafeContent4": "Transazione istantanea, nessun ritardo",
    "limitedTimeActivityTitle" : "Benefici a Tempo Limitato",
    "limitedTimeActivityTime" : "Durata dell\'Evento:  \${startDate} - \${endDate}（UTC）",
    "limitedTimeActivityTaskProcess" : "(Attualmente \${curPay}/\${targetPay})",
    "limitedTimeActivityRateTips" : "(I tassi di cambio possono variare, fate riferimento a questa pagina per informazioni precise)",
    "limitedTimeActivityNotAchieve" : "Non Completato",
    "limitedTimeActivityClaim" : "Rivendica",
    "limitedTimeActivityClaimed" : "Rivendicato",
    "limitedTimeActivityTimeLeft" : "A Tempo Limitato: \${days}g \${hours}o \${minutes}m \${seconds}s",
    "limitedTimeActivityRecord" : "Rivendica Registri",
    "limitedTimeActivityAward" : "Ricompense",
    "limitedTimeActivityGotTime" : "Tempo Rivendicato",
    "limitedTimeActivityGotRole" : "Personaggio Rivendicato",
    "limitedTimeActivityRule" : "Regole Evento",
    "limitedTimeActivity285Rule1" : "1. Durata dell\'Evento:  \${startDate} - \${endDate}（UTC）",
    "limitedTimeActivity285Rule2" : "2. Durante l\'evento, completa le attività a tempo limitato per richiedere le ricompense. Le attività sono suddivise in attività settimanali e mensili:",
    "limitedTimeActivity285Rule3" : "(1) Attività Settimanali: Ogni account è limitato al completamento di un\'attività settimanale a settimana, reimpostata ogni lunedì alle 0:00.",
    "limitedTimeActivity285Rule4" : "Attività di Accesso Settimanale: Entro un tempo limitato, accedi una volta alla pagina di ricarica del sito ufficiale.",
    "limitedTimeActivity285Rule5" : "Ricarica qualsiasi importo: Entro un tempo limitato, ricarica qualsiasi importo tramite il sito ufficiale.",
    "limitedTimeActivity285Rule6" : "(2) Attività mensili: Ogni account è limitato a un\'attività mensile al mese, reimpostata il primo di ogni mese alle 0:00.",
    "limitedTimeActivity285Rule7" : "Attività di Accesso: Entro un tempo limitato, accedi una volta alla pagina di ricarica del sito ufficiale.",
    "limitedTimeActivity285Rule8" : "Attività di Ricarica Cumulativa: Entro un tempo limitato, ricarica l\'importo richiesto per richiedere una ricompensa una volta.",
    "limitedTimeActivity285Rule9" : "Nota: A causa della lunga durata dell\'evento, i tassi di cambio potrebbero variare. Si prega di fare riferimento all\'importo visualizzato sulla pagina per l\'importo della ricarica.",
    "limitedTimeActivity285Rule10" : "3. Seleziona un personaggio prima di richiedere una ricompensa. Puoi trovare le tue ricompense nel gioco dopo averli riscattati.",
    "limitedTimeActivityClaimAward" : "Rivendica Ricompensa",
    "limitedTimeActivityConfirmGot" : "Conferma Rivendicazione",
    "limitedTimeActivityGetSucc" : "Rivendicazione Riuscita",
    "limitedTimeActivityGetFail" : "Rivendicazione non riuscita. Riprova più tardi o contatta il servizio clienti.",
    "limitedTimeActivityFrequent" : "Si prega di evitare azioni frequenti.",
    "limitedTimeActivityLoginFirst" : "Per favore fai prima il log in.",
    "limitedTimeActivityWrongParam" : "Errore nel Parametro",
    "limitedTimeActivityOverTips" : "L\'evento è scaduto. Aggiorna la pagina.",
    "preRightsIntro" : "A causa di un aggiornamento delle funzionalità, l\'evento \"Punti VIP\" verrà presto interrotto.<br/>Ora d\'Interruzione: \${offLineDate}<br/>Assicuratevi di usare i buoni ottenuti dall\'evento \"Punti VIP\" prima che scadano.<br/>Dopo la fine dell\'evento, potrai visitare il Centro Abbonamento Premium per usufruire di ulteriori vantaggi:<br/>Completa le missioni per guadagnare punti, che possono essere scambiati con buoni, oggetti di gioco e altre ricompense! Goditi vantaggi esclusivi per i membri ed estrazioni fortunate.<br/>Restate sintonizzati per scoprire altre ricompense ed eventi!",
    "riskTipTitle" : "Attenzione ai Comportamenti Illeciti e alle Truffe",
    "riskTipContent" : "Gentile Giocatore,\n\nAbbiamo notato che alcuni giocatori stanno compiendo azioni che interrompono l\'ordine e l\'equità del gioco. Le violazioni più comuni includono:\n\n1. Pubblicazione di Annunci Non Autorizzati: La condivisione di annunci non autorizzati tramite chat di gioco o altri canali, come la promozione di scambi illegali di risorse o ricariche non autorizzate.\n2. Utilizzo di Trucchi o Script: L\'utilizzo di trucchi, script o altri mezzi tecnici per ottenere risorse illegalmente.\n3. Inviti non Autorizzati: L\'invio di inviti durante la chat per invogliare i giocatori a contattarli tramite canali esterni (ad esempio, Line, Discord).\n4. Ricariche Illegali: Promozione di ricariche non ufficiali con prezzi scontati per invogliare i giocatori.\n5. Altre Truffe: Coinvolgimento in attività fraudolente, come impersonare personale ufficiale.\n\nInvitiamo tutti i giocatori a salvaguardare le proprie informazioni e risorse personali. Non fidatevi di messaggi illegali o correlati a truffe. Queste violazioni comportano rischi significativi, tra cui il potenziale furto di account o il coinvolgimento in attività fraudolente. Si prega di notare che non forniremo alcun risarcimento per le perdite derivanti da queste azioni.\n\nPer gli account trovati coinvolti in tale comportamento, adotteremo misure appropriate in base alla gravità e all\'impatto delle violazioni. Le misure possono includere, ma non sono limitate a, avvertimenti, confisca di guadagni illegali, sospensioni temporanee o ban permanenti. Se riscontrate un comportamento sospetto nel gioco, segnalatelo al nostro team di assistenza clienti. Indagheremo il prima possibile e adotteremo le misure necessarie. Grazie per la vostra comprensione e supporto.",
    "linkValid": "Il link è scaduto",
    "-" : "-",
    "accountLabel": "Account",
    "passwordLabel": "Password",
    "confirmPasswordLabel": "Conferma Password",
    "confirmDeleteTitle" : "Vuoi davvero eliminare il tuo account e tutti i personaggi?",
    "confirmDeleteYes" : "Sì. Voglio eliminare il mio account e tutti i personaggi.",
    "selectGame" : "Seleziona Gioco",
    "confirmDeleteNo" : "No. Voglio solo eliminare un personaggio. Vorrei mantenere il mio account.",
    "delTermsTitle" : "Si prega di leggere attentamente i requisiti per l\'eliminazione dell\'account e di prenderne nota.",
    "delCondTitle" : "1. Requisiti per l\'Eliminazione dell\'Account",
    "delCond1" : "(1) Si prega di accedere al vostro account prima di fare domanda. Se non riuscite ad accedere, [recuperate prima il vostro account]. Assicuratevi che l\'account di gioco e il personaggio appartengano a voi.",
    "delCond2" : "(2) Confermate che il vostro account e il vostro personaggio non presentino <span>rischi per la sicurezza</span>, inclusi reclami, segnalazioni, indagini, arbitrati o cause legali irrisolti (presentati da voi o contro di voi).",
    "delCond3" : "(3) Confermate che il vostro account e il vostro personaggio non presentino <span>pagamenti in sospeso</span>, inclusi rimborsi irrisolti o abbonamenti attivi.",
    "delNoticeTitle" : "2. Avviso di Eliminazione dell\'Account",
    "delNotice1" : "(1) L\'eliminazione di questo account di gioco e dei personaggi associati sarà <span>permanente e irreversibile</span>.",
    "delNotice2" : "(2) Prima di procedere, si prega di <span>saldare tutte le attività di gioco in sospeso</span>, compresi, ma non solo, oggetti, valuta e abbonamenti, in quanto saranno eliminati definitivamente con l\'eliminazione dell\'account. Dopo la chiusura del server di gioco, non verranno emessi rimborsi per gli account o i personaggi eliminati. \n",
    "delNotice3" : "(3) L\'eliminazione dei dati dell\'account e del personaggio rimuoverà o renderà anonime anche tutte le informazioni correlate. Tuttavia, sarà necessario scollegare e gestire manualmente i dati associati agli accessi ai social media di terze parti (ad esempio, Facebook).",
    "delNotice4" : "(4) Per tutelare i vostri interessi è previsto un periodo di 14 giorni (Periodo di Recesso), durante il quale potrete contattare l\'assistenza clienti per annullare la richiesta d\'eliminazione\'.",
    "delNotice5" : "(5) Se la richiesta viene accettata, l\'account viene immediatamente congelato, ma l\'eliminazione dei dati può richiedere fino a una settimana. Riceverete una notifica tramite e-mail al termine della procedura.",
    "delFormConfirm1" : "Ho compreso le condizioni e le conseguenze dell\'eliminazione dell\'account.",
    "delFormConfirm2" : "Questo account non presenta segnalazioni o controversie in sospeso.",
    "delForm" : "Ho letto e accetto l\'<a class=\"account-delete-link\" href=\"javascript:;\">Accordo di Cessazione Definitiva dell\'Account</a>.",
    "cannotDeleteMsgTitle" : "Impossibile eliminare l\'account",
    "cannotDeleteMsg1" : "Il tuo account non soddisfa i requisiti per l\'eliminazione:",
    "cannotDeleteMsg2" : "Hai ticket di supporto irrisolti. Risolvili prima di inviare nuovamente la richiesta.",
    "cannotDeleteMsg3" : "Hai dei rimborsi in sospeso. Ti preghiamo di saldarli prima di richiedere la l\'eliminazione dell\'account.",
    "cannotDeleteMsg4" : "Il tuo account è attualmente in fase di revisione a causa di segnalazioni o reclami dei giocatori. Attendi il completamento della revisione prima di presentare nuovamente domanda.",
    "formCompleted" : "Ticket Inviato",
    "formCheckMsg1" : "Il tuo ticket è stato inviato, attendi la revisione e la risposta.",
    "formCheckMsg2" : "Puoi controllare lo stato del ticket in <span class=\"account-delete-link\">[I Miei Ticket]</span>.",
    "delEmailMsg1" : "Desideri ricevere una notifica tramite e-mail dopo l\'eliminazione?",
    "delEmailMsg2" : "L\'eliminazione dell\'account richiederà circa una settimana a causa dell\'elaborazione dei dati. Desideri una notifica tramite e-mail al termine?",
    "delEmailMsg3" : "Il tuo indirizzo e-mail verrà utilizzato solo per scopi di notifica.",
    "delEmailConfirmYes" : "Sì, desidero essere notificato tramite e-mail.",
    "delEmailFill" : "Si prega di inserire il vostro indirizzo e-mail per la notifica.",
    "delEmailConfirmNo" : "No, non ho bisogno di notifiche tramite e-mail.",
    "delCoolMsg1" : "Desideri un periodo di recesso di 14 giorni?",
    "delCoolMsg2" : "Durante il periodo di recesso di 14 giorni, il tuo account verrà congelato, ma puoi inviare una richiesta di annullamento dell\'eliminazione in qualsiasi momento. Dopo 14 giorni, se non hai annullato, il tuo account verrà eliminato e non potrà essere recuperato.",
    "delCoolMsg3" : "Se scegli di non avere un periodo di recesso, il tuo account verrà eliminato immediatamente dopo il completamento della domanda e non potrà essere recuperato.",
    "delCoolConfirmYes" : "Sì, desidero un periodo di recesso di 14 giorni.",
    "delCoolConfirmNo" : "No, eliminalo subito.",
    "delSecondCheckMsg1" : "Siete sicuri di aver gestito tutti i contenuti dell\'account e volete attivare il periodo di recesso dell\'account? Il vostro account non sarà accessibile dopo l\'attivazione.",
    "delSecondCheckConfirmYes" : "Sì, attivalo ora.",
    "delResMsg1" : "La richiesta di eliminazione dell\'account è stata inoltrata e il seguente account è stato congelato:",
    "gameName" : "Nome Gioco:",
    "gameAccount" : "Account Gioco:",
    "delResMsg2" : "<span>Fai uno screenshot e salva le informazioni dell\'account di cui sopra, poiché è l\'unica verifica se devi ripristinare il tuo account durante il periodo di recesso</span>.",
    "delResMsg3" : "Periodo di Recesso: 14 giorni. Tempo rimanente:",
    "delResMsg4" : "Per annullare la richiesta di eliminazione durante il periodo di recesso, clicca su [Contatta l\'Assistenza].",
    "copyAccountInfo" : "Copia l\'informazione dell\'account",
    "delResMsg5" : "La richiesta di eliminazione del tuo account è stata elaborata e il tuo account è attualmente in fase di eliminazione. Pertanto, non puoi più accedervi.",
    "delResMsg6" : "A causa della grande quantità di dati coinvolti nell\'eliminazione di un account, ci vorrà del tempo. Pertanto, tutte le tracce del tuo account non verranno cancellate immediatamente. Ci aspettiamo di completare questo processo entro circa una settimana.",
    "delResMsg7" : "Se hai precedentemente fornito un indirizzo e-mail di notifica, invieremo un\'e-mail a tale indirizzo.",
    "delResMsg8" : "Se desideri accedere nuovamente al gioco, puoi registrare un nuovo account.",
    "appleOption" : "App Store",
    "googleOption" : "Google Play",
    "otherOption" : "Altri canali",
    "itemWrong" : "Si è verificato un errore con il tuo input. Si prega di riprovare.",
    "delRegisterTime" : "Data d\'Iscrizione",
    "delDevice" : "Dispositivo Usato Frequentemente",
    "delIp" : "Indirizzi IP Usati Frequentemente",
    "delHistoryPayChannel" : "Canali di Ricarica Storici",
    "delHistoryPayOrder" : "Numeri Ordini Precedenti",
    "delDeleteReason" : "Motivo dell\'Eliminazione dell\'Account",
    "delPrevStep" : "Precedente",
    "delNextStep" : "Prossimo",
    "delSecondCheckMsg2" : "Siete sicuri di aver gestito tutti i contenuti dell\'account e di voler procedere alla sua eliminazione? Una volta eseguita, l\'account non sarà più accessibile.",
    "pleaseFillIn" : "Si prega di fornire le seguenti informazioni",
    "switchNewVersion": "Passa a una Nuova",
    "switchNewVersionPlatform": "Piattaforma di Pagamento",
    "updateVersionPopupContent": "Per garantire prestazioni di gioco fluide e supporto per nuove funzionalità, ti consigliamo di aggiornare il sistema del tuo dispositivo per godere di un'esperienza di funzionamento più stabile e ottimizzazione della compatibilità.",
}